/**
 * Generated from MayaAngelouStoryLayout.fla
 */
export function MayaAngelouStoryLayout(this: IMayaAngelouStoryLayout) {
	const scene1Start = this.scene1Start;
	MayaAngelouStoryLayout_scene1Start.call(this.scene1Start);
	scene1Start.x = 0;
	scene1Start.y = 0;
	if (scene1Start.onLayout) scene1Start.onLayout();
	const scene2Likes = this.scene2Likes;
	MayaAngelouStoryLayout_scene2Likes.call(this.scene2Likes);
	scene2Likes.x = 0;
	scene2Likes.y = 0;
	if (scene2Likes.onLayout) scene2Likes.onLayout();
	const scene3Brave = this.scene3Brave;
	MayaAngelouStoryLayout_scene3Brave.call(this.scene3Brave);
	scene3Brave.x = 0;
	scene3Brave.y = 0;
	if (scene3Brave.onLayout) scene3Brave.onLayout();
	const scene4Dance = this.scene4Dance;
	MayaAngelouStoryLayout_scene4Dance.call(this.scene4Dance);
	scene4Dance.x = 0;
	scene4Dance.y = 0;
	if (scene4Dance.onLayout) scene4Dance.onLayout();
	const scene5Power = this.scene5Power;
	MayaAngelouStoryLayout_scene5Power.call(this.scene5Power);
	scene5Power.x = 0;
	scene5Power.y = 0;
	if (scene5Power.onLayout) scene5Power.onLayout();
	const scene6Bed = this.scene6Bed;
	MayaAngelouStoryLayout_scene6Bed.call(this.scene6Bed);
	scene6Bed.x = 0;
	scene6Bed.y = 0;
	if (scene6Bed.onLayout) scene6Bed.onLayout();
	const scene7End = this.scene7End;
	MayaAngelouStoryLayout_scene7End.call(this.scene7End);
	scene7End.x = 0;
	scene7End.y = 0;
	if (scene7End.onLayout) scene7End.onLayout();
	return this;
}
export function MayaAngelouStoryLayout_scene1Start(this: IMayaAngelouStoryLayout_scene1Start) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"hide id=yadinaBehindBox","isButton":false,"option":"counterpart"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_counterpart_drz_2.call(items[0] as IMayaAngelouStoryLayout_ang_counterpart_drz_2);
		(items[0] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).animation = "hide id=yadinaBehindBox";
		(items[0] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).option = "counterpart";
		items[0].x = 1009.3;
		items[0].y = 1033.65;
		if (items[0].scale) items[0].scale.x = 0.910;
		if (items[0].scale) items[0].scale.y = 0.910;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"hide id=drzBehindBox","isButton":true,"option":"counterpart"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_counterpart_drz_1.call(items[1] as IMayaAngelouStoryLayout_ang_counterpart_drz_1);
		(items[1] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).animation = "hide id=drzBehindBox";
		(items[1] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).isButton = true;
		(items[1] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).option = "counterpart";
		items[1].x = 848.6;
		items[1].y = 857.35;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"slideIn right ease=backOut","isButton":true,"option":"smart"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_drzOnChalkboard.call(items[2] as IMayaAngelouStoryLayout_drzOnChalkboard);
		(items[2] as IMayaAngelouStoryLayout_drzOnChalkboard).animation = "slideIn right ease=backOut";
		(items[2] as IMayaAngelouStoryLayout_drzOnChalkboard).isButton = true;
		(items[2] as IMayaAngelouStoryLayout_drzOnChalkboard).option = "smart";
		items[2].x = 1009.35;
		items[2].y = 1133.2;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"squishStretch","isButton":false,"option":"art"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_ang_art.call(items[3] as IMayaAngelouStoryLayout_ang_art);
		(items[3] as IMayaAngelouStoryLayout_ang_art).animation = "squishStretch";
		(items[3] as IMayaAngelouStoryLayout_ang_art).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_ang_art).option = "art";
		items[3].x = 1050.85;
		items[3].y = 1109.8;
		items[3].width = 528.00;
		items[3].height = 975.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"squishStretch delay=0.2 appear","isButton":true,"option":"art"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_ang_art_drz.call(items[4] as IMayaAngelouStoryLayout_ang_art_drz);
		(items[4] as IMayaAngelouStoryLayout_ang_art_drz).animation = "squishStretch delay=0.2 appear";
		(items[4] as IMayaAngelouStoryLayout_ang_art_drz).isButton = true;
		(items[4] as IMayaAngelouStoryLayout_ang_art_drz).option = "art";
		items[4].x = 830.7;
		items[4].y = 1137.15;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch delay=0.6 appear","isButton":false,"option":"heart"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_heart_3.call(items[5] as IMayaAngelouStoryLayout_ang_heart_3);
		(items[5] as IMayaAngelouStoryLayout_ang_heart_3).animation = "squishStretch delay=0.6 appear";
		(items[5] as IMayaAngelouStoryLayout_ang_heart_3).isButton = false;
		(items[5] as IMayaAngelouStoryLayout_ang_heart_3).option = "heart";
		items[5].x = 575.55;
		items[5].y = 396;
		items[5].width = 363.00;
		items[5].height = 315.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch delay=0.4 appear","isButton":false,"option":"heart"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_heart_2.call(items[6] as IMayaAngelouStoryLayout_ang_heart_2);
		(items[6] as IMayaAngelouStoryLayout_ang_heart_2).animation = "squishStretch delay=0.4 appear";
		(items[6] as IMayaAngelouStoryLayout_ang_heart_2).isButton = false;
		(items[6] as IMayaAngelouStoryLayout_ang_heart_2).option = "heart";
		items[6].x = 1526.05;
		items[6].y = 526.3;
		items[6].width = 455.00;
		items[6].height = 380.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":true,"option":"heart"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_drzHeart.call(items[7] as IMayaAngelouStoryLayout_drzHeart);
		(items[7] as IMayaAngelouStoryLayout_drzHeart).animation = "squishStretch";
		(items[7] as IMayaAngelouStoryLayout_drzHeart).isButton = true;
		(items[7] as IMayaAngelouStoryLayout_drzHeart).option = "heart";
		items[7].x = 986.8;
		items[7].y = 822.9;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"from drzBehindBox delay=0.6 appear","isButton":true,"option":"counterpart"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_counterpart_drz_1.call(items[8] as IMayaAngelouStoryLayout_ang_counterpart_drz_1);
		(items[8] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).animation = "from drzBehindBox delay=0.6 appear";
		(items[8] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).isButton = true;
		(items[8] as IMayaAngelouStoryLayout_ang_counterpart_drz_1).option = "counterpart";
		items[8].x = 767.7;
		items[8].y = 663.55;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"from yadinaBehindBox delay=0.4 appear","isButton":true,"option":"counterpart"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_ang_counterpart_drz_2.call(items[9] as IMayaAngelouStoryLayout_ang_counterpart_drz_2);
		(items[9] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).animation = "from yadinaBehindBox delay=0.4 appear";
		(items[9] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).isButton = true;
		(items[9] as IMayaAngelouStoryLayout_ang_counterpart_drz_2).option = "counterpart";
		items[9].x = 1082.8;
		items[9].y = 648.6;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch","isButton":false,"option":"counterpart"});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_ang_counterpart.call(items[10] as IMayaAngelouStoryLayout_ang_counterpart);
		(items[10] as IMayaAngelouStoryLayout_ang_counterpart).animation = "squishStretch";
		(items[10] as IMayaAngelouStoryLayout_ang_counterpart).isButton = false;
		(items[10] as IMayaAngelouStoryLayout_ang_counterpart).option = "counterpart";
		items[10].x = 1004.5;
		items[10].y = 1139.45;
		items[10].width = 757.00;
		items[10].height = 660.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_counterpart_drz_2(this: IMayaAngelouStoryLayout_ang_counterpart_drz_2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonYadinaCounterpart.call(items[0] as IMayaAngelouStoryLayout_buttonYadinaCounterpart);
		items[0].x = 0;
		items[0].y = -217;
		items[0].width = 598.00;
		items[0].height = 434.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonYadinaCounterpart(this: IMayaAngelouStoryLayout_buttonYadinaCounterpart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart_drz_2.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_counterpart_drz_1(this: IMayaAngelouStoryLayout_ang_counterpart_drz_1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzCounterpart.call(items[0] as IMayaAngelouStoryLayout_buttonDrzCounterpart);
		items[0].x = 0;
		items[0].y = -110.5;
		items[0].width = 213.00;
		items[0].height = 221.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzCounterpart(this: IMayaAngelouStoryLayout_buttonDrzCounterpart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart_drz_1.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzOnChalkboard(this: IMayaAngelouStoryLayout_drzOnChalkboard) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_smart.call(items[0] as IMayaAngelouStoryLayout_ang_smart);
		(items[0] as IMayaAngelouStoryLayout_ang_smart).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_smart).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_smart).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 1056.00;
		items[0].height = 835.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":""});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_smart_drz.call(items[1] as IMayaAngelouStoryLayout_ang_smart_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_smart_drz).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_smart_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_smart_drz).option = "";
		items[1].x = -215.25;
		items[1].y = -830.65;
		items[1].width = 210.00;
		items[1].height = 229.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_smart(this: IMayaAngelouStoryLayout_ang_smart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_smart.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_smart_drz(this: IMayaAngelouStoryLayout_ang_smart_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_smart_drz.png", 0.533, 0.694);
	return this;
}
function MayaAngelouStoryLayout_ang_art(this: IMayaAngelouStoryLayout_ang_art) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_art.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_art_drz(this: IMayaAngelouStoryLayout_ang_art_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_drzButtonArt.call(items[0] as IMayaAngelouStoryLayout_drzButtonArt);
		items[0].x = 52;
		items[0].y = -106.5;
		items[0].width = 376.00;
		items[0].height = 229.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_drzButtonArt(this: IMayaAngelouStoryLayout_drzButtonArt) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_art_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_heart_3(this: IMayaAngelouStoryLayout_ang_heart_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_3.png", 0.501, 0.502);
	return this;
}
function MayaAngelouStoryLayout_ang_heart_2(this: IMayaAngelouStoryLayout_ang_heart_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_2.png", 0.501, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzHeart(this: IMayaAngelouStoryLayout_drzHeart) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch delay=0.2 appear","isButton":false,"option":"heart"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_heart_drz.call(items[0] as IMayaAngelouStoryLayout_ang_heart_drz);
		(items[0] as IMayaAngelouStoryLayout_ang_heart_drz).animation = "squishStretch delay=0.2 appear";
		(items[0] as IMayaAngelouStoryLayout_ang_heart_drz).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_heart_drz).option = "heart";
		items[0].x = 12.6;
		items[0].y = 280.6;
		items[0].width = 255.00;
		items[0].height = 277.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"heart"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_heart_1.call(items[1] as IMayaAngelouStoryLayout_ang_heart_1);
		(items[1] as IMayaAngelouStoryLayout_ang_heart_1).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_heart_1).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_heart_1).option = "heart";
		items[1].x = 0;
		items[1].y = 0.5;
		items[1].width = 742.00;
		items[1].height = 585.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch delay=0.2 appear","isButton":false,"option":"heart"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_heart_drz_front.call(items[2] as IMayaAngelouStoryLayout_ang_heart_drz_front);
		(items[2] as IMayaAngelouStoryLayout_ang_heart_drz_front).animation = "squishStretch delay=0.2 appear";
		(items[2] as IMayaAngelouStoryLayout_ang_heart_drz_front).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_heart_drz_front).option = "heart";
		items[2].x = 28.85;
		items[2].y = 280;
		items[2].width = 180.00;
		items[2].height = 106.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_heart_drz(this: IMayaAngelouStoryLayout_ang_heart_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_drz.png", 0.502, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_heart_1(this: IMayaAngelouStoryLayout_ang_heart_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_1.png", 0.500, 0.501);
	return this;
}
function MayaAngelouStoryLayout_ang_heart_drz_front(this: IMayaAngelouStoryLayout_ang_heart_drz_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_heart_drz_front.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_counterpart(this: IMayaAngelouStoryLayout_ang_counterpart) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_counterpart.png", 0.500, 1.000);
	return this;
}
export function MayaAngelouStoryLayout_scene2Likes(this: IMayaAngelouStoryLayout_scene2Likes) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"slideIn left time=0.6 delay=0.4","isButton":false,"option":"party"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_turtle_drink_3.call(items[0] as IMayaAngelouStoryLayout_ang_turtle_drink_3);
		(items[0] as IMayaAngelouStoryLayout_ang_turtle_drink_3).animation = "slideIn left time=0.6 delay=0.4";
		(items[0] as IMayaAngelouStoryLayout_ang_turtle_drink_3).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_turtle_drink_3).option = "party";
		items[0].x = 1025.3;
		items[0].y = 789.6;
		items[0].width = 382.00;
		items[0].height = 655.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"jump delay=0.3","isButton":false,"option":"marshmallow"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_marshmallowsbg.call(items[1] as IMayaAngelouStoryLayout_ang_marshmallowsbg);
		(items[1] as IMayaAngelouStoryLayout_ang_marshmallowsbg).animation = "jump delay=0.3";
		(items[1] as IMayaAngelouStoryLayout_ang_marshmallowsbg).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_marshmallowsbg).option = "marshmallow";
		items[1].x = 842.1;
		items[1].y = 871.7;
		items[1].width = 271.00;
		items[1].height = 179.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch","isButton":false,"option":"jelly"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_teaset.call(items[2] as IMayaAngelouStoryLayout_ang_teaset);
		(items[2] as IMayaAngelouStoryLayout_ang_teaset).animation = "squishStretch";
		(items[2] as IMayaAngelouStoryLayout_ang_teaset).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_teaset).option = "jelly";
		items[2].x = 466.85;
		items[2].y = 1004;
		items[2].width = 593.00;
		items[2].height = 227.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"squishStretch","isButton":false,"option":"party"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_ang_teaset.call(items[3] as IMayaAngelouStoryLayout_ang_teaset);
		(items[3] as IMayaAngelouStoryLayout_ang_teaset).animation = "squishStretch";
		(items[3] as IMayaAngelouStoryLayout_ang_teaset).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_ang_teaset).option = "party";
		items[3].x = 466.85;
		items[3].y = 1004;
		items[3].width = 593.00;
		items[3].height = 227.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"jump delay=0.3","isButton":false,"option":"marshmallow"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_ang_teaset.call(items[4] as IMayaAngelouStoryLayout_ang_teaset);
		(items[4] as IMayaAngelouStoryLayout_ang_teaset).animation = "jump delay=0.3";
		(items[4] as IMayaAngelouStoryLayout_ang_teaset).isButton = false;
		(items[4] as IMayaAngelouStoryLayout_ang_teaset).option = "marshmallow";
		items[4].x = 466.85;
		items[4].y = 1004;
		items[4].width = 593.00;
		items[4].height = 227.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_teaset.call(items[5] as IMayaAngelouStoryLayout_ang_teaset);
		(items[5] as IMayaAngelouStoryLayout_ang_teaset).animation = "squishStretch";
		(items[5] as IMayaAngelouStoryLayout_ang_teaset).isButton = false;
		(items[5] as IMayaAngelouStoryLayout_ang_teaset).option = "sea";
		items[5].x = 466.85;
		items[5].y = 1004;
		items[5].width = 593.00;
		items[5].height = 227.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"slideIn right time=0.6 delay=0.2","isButton":true,"option":"jelly"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_sandwich.call(items[6] as IMayaAngelouStoryLayout_ang_sandwich);
		(items[6] as IMayaAngelouStoryLayout_ang_sandwich).animation = "slideIn right time=0.6 delay=0.2";
		(items[6] as IMayaAngelouStoryLayout_ang_sandwich).isButton = true;
		(items[6] as IMayaAngelouStoryLayout_ang_sandwich).option = "jelly";
		items[6].x = 1492.5;
		items[6].y = 1021.75;
		items[6].width = 783.00;
		items[6].height = 634.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":true,"option":"jelly"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_ang_sandwich_drz.call(items[7] as IMayaAngelouStoryLayout_ang_sandwich_drz);
		(items[7] as IMayaAngelouStoryLayout_ang_sandwich_drz).animation = "squishStretch";
		(items[7] as IMayaAngelouStoryLayout_ang_sandwich_drz).isButton = true;
		(items[7] as IMayaAngelouStoryLayout_ang_sandwich_drz).option = "jelly";
		items[7].x = 992.85;
		items[7].y = 1023.3;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"slideIn right time=0.6 delay=0.2","isButton":false,"option":"party"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_turtle_balloons_2.call(items[8] as IMayaAngelouStoryLayout_ang_turtle_balloons_2);
		(items[8] as IMayaAngelouStoryLayout_ang_turtle_balloons_2).animation = "slideIn right time=0.6 delay=0.2";
		(items[8] as IMayaAngelouStoryLayout_ang_turtle_balloons_2).isButton = false;
		(items[8] as IMayaAngelouStoryLayout_ang_turtle_balloons_2).option = "party";
		items[8].x = 1699.45;
		items[8].y = 1054.85;
		items[8].width = 589.00;
		items[8].height = 999.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"squishStretch","isButton":true,"option":"party"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_ang_turtle_drz.call(items[9] as IMayaAngelouStoryLayout_ang_turtle_drz);
		(items[9] as IMayaAngelouStoryLayout_ang_turtle_drz).animation = "squishStretch";
		(items[9] as IMayaAngelouStoryLayout_ang_turtle_drz).isButton = true;
		(items[9] as IMayaAngelouStoryLayout_ang_turtle_drz).option = "party";
		items[9].x = 1086.05;
		items[9].y = 1118.1;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"jump delay=0.3","isButton":false,"option":"marshmallow"});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_ang_marshmallows3.call(items[10] as IMayaAngelouStoryLayout_ang_marshmallows3);
		(items[10] as IMayaAngelouStoryLayout_ang_marshmallows3).animation = "jump delay=0.3";
		(items[10] as IMayaAngelouStoryLayout_ang_marshmallows3).isButton = false;
		(items[10] as IMayaAngelouStoryLayout_ang_marshmallows3).option = "marshmallow";
		items[10].x = 1828.6;
		items[10].y = 886.95;
		items[10].width = 312.00;
		items[10].height = 179.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"jump delay=0.3","isButton":false,"option":"marshmallow"});
	}
	if (items[11]) {
		MayaAngelouStoryLayout_ang_marshmallows2.call(items[11] as IMayaAngelouStoryLayout_ang_marshmallows2);
		(items[11] as IMayaAngelouStoryLayout_ang_marshmallows2).animation = "jump delay=0.3";
		(items[11] as IMayaAngelouStoryLayout_ang_marshmallows2).isButton = false;
		(items[11] as IMayaAngelouStoryLayout_ang_marshmallows2).option = "marshmallow";
		items[11].x = 1730;
		items[11].y = 1150.7;
		items[11].width = 233.00;
		items[11].height = 159.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"jump delay=0.3","isButton":false,"option":"marshmallow"});
	}
	if (items[12]) {
		MayaAngelouStoryLayout_ang_marshmallows1.call(items[12] as IMayaAngelouStoryLayout_ang_marshmallows1);
		(items[12] as IMayaAngelouStoryLayout_ang_marshmallows1).animation = "jump delay=0.3";
		(items[12] as IMayaAngelouStoryLayout_ang_marshmallows1).isButton = false;
		(items[12] as IMayaAngelouStoryLayout_ang_marshmallows1).option = "marshmallow";
		items[12].x = 953.45;
		items[12].y = 1056.95;
		items[12].width = 232.00;
		items[12].height = 155.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"drop","isButton":false,"option":"marshmallow"});
	}
	if (items[13]) {
		MayaAngelouStoryLayout_drzPie.call(items[13] as IMayaAngelouStoryLayout_drzPie);
		(items[13] as IMayaAngelouStoryLayout_drzPie).animation = "drop";
		(items[13] as IMayaAngelouStoryLayout_drzPie).isButton = false;
		(items[13] as IMayaAngelouStoryLayout_drzPie).option = "marshmallow";
		items[13].x = 1371.6;
		items[13].y = 1004.05;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[14]) {
		MayaAngelouStoryLayout_ang_sea_fish.call(items[14] as IMayaAngelouStoryLayout_ang_sea_fish);
		(items[14] as IMayaAngelouStoryLayout_ang_sea_fish).animation = "squishStretch";
		(items[14] as IMayaAngelouStoryLayout_ang_sea_fish).isButton = false;
		(items[14] as IMayaAngelouStoryLayout_ang_sea_fish).option = "sea";
		items[14].x = 740.75;
		items[14].y = 551.6;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[15]) {
		MayaAngelouStoryLayout_ang_sea_whale.call(items[15] as IMayaAngelouStoryLayout_ang_sea_whale);
		(items[15] as IMayaAngelouStoryLayout_ang_sea_whale).animation = "squishStretch";
		(items[15] as IMayaAngelouStoryLayout_ang_sea_whale).isButton = false;
		(items[15] as IMayaAngelouStoryLayout_ang_sea_whale).option = "sea";
		items[15].x = 1700.75;
		items[15].y = 183.85;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[16]) {
		MayaAngelouStoryLayout_ang_sea_plant2.call(items[16] as IMayaAngelouStoryLayout_ang_sea_plant2);
		(items[16] as IMayaAngelouStoryLayout_ang_sea_plant2).animation = "squishStretch";
		(items[16] as IMayaAngelouStoryLayout_ang_sea_plant2).isButton = false;
		(items[16] as IMayaAngelouStoryLayout_ang_sea_plant2).option = "sea";
		items[16].x = 1628.1;
		items[16].y = 1098.5;
		items[16].width = 667.00;
		items[16].height = 346.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[17]) {
		MayaAngelouStoryLayout_ang_sea_plant1.call(items[17] as IMayaAngelouStoryLayout_ang_sea_plant1);
		(items[17] as IMayaAngelouStoryLayout_ang_sea_plant1).animation = "squishStretch";
		(items[17] as IMayaAngelouStoryLayout_ang_sea_plant1).isButton = false;
		(items[17] as IMayaAngelouStoryLayout_ang_sea_plant1).option = "sea";
		items[17].x = 929.25;
		items[17].y = 1069.4;
		items[17].width = 444.00;
		items[17].height = 541.00;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"float delay=1.6 speed=0.8 time=1.4","isButton":false,"option":"sea"});
	}
	if (items[18]) {
		MayaAngelouStoryLayout_ang_sea_bubbles11.call(items[18] as IMayaAngelouStoryLayout_ang_sea_bubbles11);
		(items[18] as IMayaAngelouStoryLayout_ang_sea_bubbles11).animation = "float delay=1.6 speed=0.8 time=1.4";
		(items[18] as IMayaAngelouStoryLayout_ang_sea_bubbles11).isButton = false;
		(items[18] as IMayaAngelouStoryLayout_ang_sea_bubbles11).option = "sea";
		items[18].x = 929.7;
		items[18].y = 357.6;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[19]) {
		MayaAngelouStoryLayout_ang_sea_bubbles21.call(items[19] as IMayaAngelouStoryLayout_ang_sea_bubbles21);
		(items[19] as IMayaAngelouStoryLayout_ang_sea_bubbles21).animation = "squishStretch";
		(items[19] as IMayaAngelouStoryLayout_ang_sea_bubbles21).isButton = false;
		(items[19] as IMayaAngelouStoryLayout_ang_sea_bubbles21).option = "sea";
		items[19].x = 1719.35;
		items[19].y = 608.55;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,{"animation":"squishStretch","isButton":false,"option":"sea"});
	}
	if (items[20]) {
		MayaAngelouStoryLayout_ang_sea_drz1.call(items[20] as IMayaAngelouStoryLayout_ang_sea_drz1);
		(items[20] as IMayaAngelouStoryLayout_ang_sea_drz1).animation = "squishStretch";
		(items[20] as IMayaAngelouStoryLayout_ang_sea_drz1).isButton = false;
		(items[20] as IMayaAngelouStoryLayout_ang_sea_drz1).option = "sea";
		items[20].x = 1310.1;
		items[20].y = 537.6;
		if (items[20].onLayout) items[20].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_turtle_drink_3(this: IMayaAngelouStoryLayout_ang_turtle_drink_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_left.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_marshmallowsbg(this: IMayaAngelouStoryLayout_ang_marshmallowsbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallowsbg.png", 0.502, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_teaset(this: IMayaAngelouStoryLayout_ang_teaset) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_teaset.png", 0.501, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_sandwich(this: IMayaAngelouStoryLayout_ang_sandwich) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sandwich.png", 0.501, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_sandwich_drz(this: IMayaAngelouStoryLayout_ang_sandwich_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzJelly.call(items[0] as IMayaAngelouStoryLayout_buttonDrzJelly);
		items[0].x = -0.5;
		items[0].y = -171;
		items[0].width = 385.00;
		items[0].height = 342.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzJelly(this: IMayaAngelouStoryLayout_buttonDrzJelly) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sandwich_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_turtle_balloons_2(this: IMayaAngelouStoryLayout_ang_turtle_balloons_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_right.png", 0.501, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_turtle_drz(this: IMayaAngelouStoryLayout_ang_turtle_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzParty.call(items[0] as IMayaAngelouStoryLayout_buttonDrzParty);
		items[0].x = 28.5;
		items[0].y = -294;
		items[0].width = 627.00;
		items[0].height = 588.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzParty(this: IMayaAngelouStoryLayout_buttonDrzParty) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_turtle_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_marshmallows3(this: IMayaAngelouStoryLayout_ang_marshmallows3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows3.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_marshmallows2(this: IMayaAngelouStoryLayout_ang_marshmallows2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows2.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_marshmallows1(this: IMayaAngelouStoryLayout_ang_marshmallows1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_marshmallows1.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_drzPie(this: IMayaAngelouStoryLayout_drzPie) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"marshmallow"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_pie.call(items[0] as IMayaAngelouStoryLayout_ang_pie);
		(items[0] as IMayaAngelouStoryLayout_ang_pie).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_pie).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_pie).option = "marshmallow";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 604.00;
		items[0].height = 307.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"jump delay=0.2","isButton":true,"option":"marshmallow"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_pie_drz.call(items[1] as IMayaAngelouStoryLayout_ang_pie_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_pie_drz).animation = "jump delay=0.2";
		(items[1] as IMayaAngelouStoryLayout_ang_pie_drz).isButton = true;
		(items[1] as IMayaAngelouStoryLayout_ang_pie_drz).option = "marshmallow";
		items[1].x = 131.65;
		items[1].y = -175;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_pie(this: IMayaAngelouStoryLayout_ang_pie) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pie.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_pie_drz(this: IMayaAngelouStoryLayout_ang_pie_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzMarshmellow.call(items[0] as IMayaAngelouStoryLayout_buttonDrzMarshmellow);
		items[0].x = 0;
		items[0].y = -117;
		items[0].width = 253.00;
		items[0].height = 234.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzMarshmellow(this: IMayaAngelouStoryLayout_buttonDrzMarshmellow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pie_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_fish(this: IMayaAngelouStoryLayout_ang_sea_fish) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=1.2 speed=0.7 time=1.4","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_fishFloat.call(items[0] as IMayaAngelouStoryLayout_fishFloat);
		(items[0] as IMayaAngelouStoryLayout_fishFloat).animation = "float delay=1.2 speed=0.7 time=1.4";
		(items[0] as IMayaAngelouStoryLayout_fishFloat).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_fishFloat).option = "";
		items[0].x = -0.5;
		items[0].y = -0.5;
		items[0].width = 167.00;
		items[0].height = 167.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_fishFloat(this: IMayaAngelouStoryLayout_fishFloat) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_fish.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_whale(this: IMayaAngelouStoryLayout_ang_sea_whale) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=1 speed=0.7 time=1.4","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_whaleFloat.call(items[0] as IMayaAngelouStoryLayout_whaleFloat);
		(items[0] as IMayaAngelouStoryLayout_whaleFloat).animation = "float delay=1 speed=0.7 time=1.4";
		(items[0] as IMayaAngelouStoryLayout_whaleFloat).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_whaleFloat).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 606.00;
		items[0].height = 312.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_whaleFloat(this: IMayaAngelouStoryLayout_whaleFloat) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_whale.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_plant2(this: IMayaAngelouStoryLayout_ang_sea_plant2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_right.png", 0.501, 1.006);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_plant1(this: IMayaAngelouStoryLayout_ang_sea_plant1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_left.png", 0.313, 0.961);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_bubbles11(this: IMayaAngelouStoryLayout_ang_sea_bubbles11) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=0.6 speed=0.8 time=1.4","isButton":false,"option":"sea"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sea_bubbles1.call(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles1);
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles1).animation = "float delay=0.6 speed=0.8 time=1.4";
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles1).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles1).option = "sea";
		items[0].x = 0;
		items[0].y = 0.5;
		items[0].width = 304.00;
		items[0].height = 427.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sea_bubbles1(this: IMayaAngelouStoryLayout_ang_sea_bubbles1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_bubbles1.png", 0.500, 0.501);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_bubbles21(this: IMayaAngelouStoryLayout_ang_sea_bubbles21) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=0.4 speed=0.8 time=1.4","isButton":false,"option":"sea"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sea_bubbles2.call(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles2);
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles2).animation = "float delay=0.4 speed=0.8 time=1.4";
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles2).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sea_bubbles2).option = "sea";
		items[0].x = 0.5;
		items[0].y = 0.5;
		items[0].width = 499.00;
		items[0].height = 427.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sea_bubbles2(this: IMayaAngelouStoryLayout_ang_sea_bubbles2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_bubbles2.png", 0.501, 0.501);
	return this;
}
function MayaAngelouStoryLayout_ang_sea_drz1(this: IMayaAngelouStoryLayout_ang_sea_drz1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=0.2 time=1.4","isButton":true,"option":"sea"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sea_drz.call(items[0] as IMayaAngelouStoryLayout_ang_sea_drz);
		(items[0] as IMayaAngelouStoryLayout_ang_sea_drz).animation = "float delay=0.2 time=1.4";
		(items[0] as IMayaAngelouStoryLayout_ang_sea_drz).isButton = true;
		(items[0] as IMayaAngelouStoryLayout_ang_sea_drz).option = "sea";
		items[0].x = 0.5;
		items[0].y = 0.5;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sea_drz(this: IMayaAngelouStoryLayout_ang_sea_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzSea.call(items[0] as IMayaAngelouStoryLayout_buttonDrzSea);
		items[0].x = -0.5;
		items[0].y = -0.5;
		items[0].width = 389.00;
		items[0].height = 333.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSea(this: IMayaAngelouStoryLayout_buttonDrzSea) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sea_drz.png", 0.500, 0.500);
	return this;
}
export function MayaAngelouStoryLayout_scene3Brave(this: IMayaAngelouStoryLayout_scene3Brave) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"wings"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_wings_cloud3.call(items[0] as IMayaAngelouStoryLayout_ang_wings_cloud3);
		(items[0] as IMayaAngelouStoryLayout_ang_wings_cloud3).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_wings_cloud3).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_wings_cloud3).option = "wings";
		items[0].x = 863.1;
		items[0].y = 349.35;
		items[0].width = 1407.00;
		items[0].height = 365.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"wings"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_wings_cloud2.call(items[1] as IMayaAngelouStoryLayout_ang_wings_cloud2);
		(items[1] as IMayaAngelouStoryLayout_ang_wings_cloud2).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_wings_cloud2).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_wings_cloud2).option = "wings";
		items[1].x = 1875.7;
		items[1].y = 902.6;
		items[1].width = 1190.00;
		items[1].height = 501.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"wings"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_wings_cloud1.call(items[2] as IMayaAngelouStoryLayout_ang_wings_cloud1);
		(items[2] as IMayaAngelouStoryLayout_ang_wings_cloud1).animation = "";
		(items[2] as IMayaAngelouStoryLayout_ang_wings_cloud1).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_wings_cloud1).option = "wings";
		items[2].x = 351.45;
		items[2].y = 956.5;
		items[2].width = 1067.00;
		items[2].height = 183.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"hide id=duckBottomRight","isButton":false,"option":"springs"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_ang_springs_duck_right.call(items[3] as IMayaAngelouStoryLayout_ang_springs_duck_right);
		(items[3] as IMayaAngelouStoryLayout_ang_springs_duck_right).animation = "hide id=duckBottomRight";
		(items[3] as IMayaAngelouStoryLayout_ang_springs_duck_right).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_ang_springs_duck_right).option = "springs";
		items[3].x = 1395.15;
		items[3].y = 996.05;
		items[3].width = 361.00;
		items[3].height = 334.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"hide id=duckBottomLeft","isButton":false,"option":"springs"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_ang_springs_duck_left.call(items[4] as IMayaAngelouStoryLayout_ang_springs_duck_left);
		(items[4] as IMayaAngelouStoryLayout_ang_springs_duck_left).animation = "hide id=duckBottomLeft";
		(items[4] as IMayaAngelouStoryLayout_ang_springs_duck_left).isButton = false;
		(items[4] as IMayaAngelouStoryLayout_ang_springs_duck_left).option = "springs";
		items[4].x = 644.25;
		items[4].y = 962.3;
		items[4].width = 331.00;
		items[4].height = 305.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo delay=0.6 appear","isButton":false,"option":"springs"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_springs_spring.call(items[5] as IMayaAngelouStoryLayout_ang_springs_spring);
		(items[5] as IMayaAngelouStoryLayout_ang_springs_spring).animation = "squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo delay=0.6 appear";
		(items[5] as IMayaAngelouStoryLayout_ang_springs_spring).isButton = false;
		(items[5] as IMayaAngelouStoryLayout_ang_springs_spring).option = "springs";
		items[5].x = 1388.25;
		items[5].y = 1042.35;
		items[5].width = 72.71;
		items[5].height = 121.86;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo delay=0.4 appear","isButton":false,"option":"springs"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_springs_spring.call(items[6] as IMayaAngelouStoryLayout_ang_springs_spring);
		(items[6] as IMayaAngelouStoryLayout_ang_springs_spring).animation = "squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo delay=0.4 appear";
		(items[6] as IMayaAngelouStoryLayout_ang_springs_spring).isButton = false;
		(items[6] as IMayaAngelouStoryLayout_ang_springs_spring).option = "springs";
		items[6].x = 642.05;
		items[6].y = 1001.5;
		items[6].width = 66.53;
		items[6].height = 111.50;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"from duckBottomRight time=0.6 ease=squishStretch repeat=10 yoyo delay=0.6 appear","isButton":false,"option":"springs"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_ang_springs_duck_right.call(items[7] as IMayaAngelouStoryLayout_ang_springs_duck_right);
		(items[7] as IMayaAngelouStoryLayout_ang_springs_duck_right).animation = "from duckBottomRight time=0.6 ease=squishStretch repeat=10 yoyo delay=0.6 appear";
		(items[7] as IMayaAngelouStoryLayout_ang_springs_duck_right).isButton = false;
		(items[7] as IMayaAngelouStoryLayout_ang_springs_duck_right).option = "springs";
		items[7].x = 1395.15;
		items[7].y = 951.05;
		items[7].width = 361.00;
		items[7].height = 334.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"from duckBottomLeft time=0.6 ease=squishStretch repeat=10 yoyo delay=0.4 appear","isButton":false,"option":"springs"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_springs_duck_left.call(items[8] as IMayaAngelouStoryLayout_ang_springs_duck_left);
		(items[8] as IMayaAngelouStoryLayout_ang_springs_duck_left).animation = "from duckBottomLeft time=0.6 ease=squishStretch repeat=10 yoyo delay=0.4 appear";
		(items[8] as IMayaAngelouStoryLayout_ang_springs_duck_left).isButton = false;
		(items[8] as IMayaAngelouStoryLayout_ang_springs_duck_left).option = "springs";
		items[8].x = 644.25;
		items[8].y = 917.3;
		items[8].width = 331.00;
		items[8].height = 305.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":false,"option":"springs"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_ang_springs_butterflies_2.call(items[9] as IMayaAngelouStoryLayout_ang_springs_butterflies_2);
		(items[9] as IMayaAngelouStoryLayout_ang_springs_butterflies_2).animation = "";
		(items[9] as IMayaAngelouStoryLayout_ang_springs_butterflies_2).isButton = false;
		(items[9] as IMayaAngelouStoryLayout_ang_springs_butterflies_2).option = "springs";
		items[9].x = 1332.8;
		items[9].y = 373.6;
		items[9].width = 450.00;
		items[9].height = 331.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":false,"option":"springs"});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_ang_springs_butterflies_1.call(items[10] as IMayaAngelouStoryLayout_ang_springs_butterflies_1);
		(items[10] as IMayaAngelouStoryLayout_ang_springs_butterflies_1).animation = "";
		(items[10] as IMayaAngelouStoryLayout_ang_springs_butterflies_1).isButton = false;
		(items[10] as IMayaAngelouStoryLayout_ang_springs_butterflies_1).option = "springs";
		items[10].x = 576;
		items[10].y = 315.5;
		items[10].width = 337.00;
		items[10].height = 321.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"isPaperLayer":true});
	}
	if (items[11]) {
		MayaAngelouStoryLayout_paperLayer.call(items[11] as IMayaAngelouStoryLayout_paperLayer);
		(items[11] as IMayaAngelouStoryLayout_paperLayer).isPaperLayer = true;
		items[11].x = 0;
		items[11].y = 0;
		items[11].width = 2048.00;
		items[11].height = 1536.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"squishStretch","isButton":true,"option":"wings"});
	}
	if (items[12]) {
		MayaAngelouStoryLayout_drzWings.call(items[12] as IMayaAngelouStoryLayout_drzWings);
		(items[12] as IMayaAngelouStoryLayout_drzWings).animation = "squishStretch";
		(items[12] as IMayaAngelouStoryLayout_drzWings).isButton = true;
		(items[12] as IMayaAngelouStoryLayout_drzWings).option = "wings";
		items[12].x = 1238.35;
		items[12].y = 638.2;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"hide id=duckBottom ","isButton":false,"option":"springs"});
	}
	if (items[13]) {
		MayaAngelouStoryLayout_ang_springs_drz.call(items[13] as IMayaAngelouStoryLayout_ang_springs_drz);
		(items[13] as IMayaAngelouStoryLayout_ang_springs_drz).animation = "hide id=duckBottom ";
		(items[13] as IMayaAngelouStoryLayout_ang_springs_drz).isButton = false;
		(items[13] as IMayaAngelouStoryLayout_ang_springs_drz).option = "springs";
		items[13].x = 995.6;
		items[13].y = 1105;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo","isButton":false,"option":"springs"});
	}
	if (items[14]) {
		MayaAngelouStoryLayout_ang_springs_spring.call(items[14] as IMayaAngelouStoryLayout_ang_springs_spring);
		(items[14] as IMayaAngelouStoryLayout_ang_springs_spring).animation = "squishStretch 1.1 0.5 time=0.6 repeat=10 yoyo";
		(items[14] as IMayaAngelouStoryLayout_ang_springs_spring).isButton = false;
		(items[14] as IMayaAngelouStoryLayout_ang_springs_spring).option = "springs";
		items[14].x = 991.5;
		items[14].y = 1167.7;
		items[14].width = 108.00;
		items[14].height = 181.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"from duckBottom time=0.6 ease=squishStretch repeat=10 yoyo","isButton":true,"option":"springs"});
	}
	if (items[15]) {
		MayaAngelouStoryLayout_ang_springs_drz.call(items[15] as IMayaAngelouStoryLayout_ang_springs_drz);
		(items[15] as IMayaAngelouStoryLayout_ang_springs_drz).animation = "from duckBottom time=0.6 ease=squishStretch repeat=10 yoyo";
		(items[15] as IMayaAngelouStoryLayout_ang_springs_drz).isButton = true;
		(items[15] as IMayaAngelouStoryLayout_ang_springs_drz).option = "springs";
		items[15].x = 995.6;
		items[15].y = 1029.25;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"squishStretch","isButton":false,"option":"rings"});
	}
	if (items[16]) {
		MayaAngelouStoryLayout_ang_onionrings.call(items[16] as IMayaAngelouStoryLayout_ang_onionrings);
		(items[16] as IMayaAngelouStoryLayout_ang_onionrings).animation = "squishStretch";
		(items[16] as IMayaAngelouStoryLayout_ang_onionrings).isButton = false;
		(items[16] as IMayaAngelouStoryLayout_ang_onionrings).option = "rings";
		items[16].x = 909.9;
		items[16].y = 1037.25;
		items[16].width = 772.00;
		items[16].height = 266.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch delay=0.2 appear","isButton":true,"option":"rings"});
	}
	if (items[17]) {
		MayaAngelouStoryLayout_ang_onionrings_drz.call(items[17] as IMayaAngelouStoryLayout_ang_onionrings_drz);
		(items[17] as IMayaAngelouStoryLayout_ang_onionrings_drz).animation = "squishStretch delay=0.2 appear";
		(items[17] as IMayaAngelouStoryLayout_ang_onionrings_drz).isButton = true;
		(items[17] as IMayaAngelouStoryLayout_ang_onionrings_drz).option = "rings";
		items[17].x = 1263.65;
		items[17].y = 993.7;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"","isButton":true,"option":"swings"});
	}
	if (items[18]) {
		MayaAngelouStoryLayout_buttonDrzSwings1.call(items[18] as IMayaAngelouStoryLayout_buttonDrzSwings1);
		(items[18] as IMayaAngelouStoryLayout_buttonDrzSwings1).animation = "";
		(items[18] as IMayaAngelouStoryLayout_buttonDrzSwings1).isButton = true;
		(items[18] as IMayaAngelouStoryLayout_buttonDrzSwings1).option = "swings";
		items[18].x = 1065.2;
		items[18].y = 673.8;
		if (items[18].onLayout) items[18].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_wings_cloud3(this: IMayaAngelouStoryLayout_ang_wings_cloud3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud3.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_wings_cloud2(this: IMayaAngelouStoryLayout_ang_wings_cloud2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud2.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_wings_cloud1(this: IMayaAngelouStoryLayout_ang_wings_cloud1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_cloud1.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_duck_right(this: IMayaAngelouStoryLayout_ang_springs_duck_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_duck_right.png", 0.385, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_duck_left(this: IMayaAngelouStoryLayout_ang_springs_duck_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_duck_left.png", 0.622, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_spring(this: IMayaAngelouStoryLayout_ang_springs_spring) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_spring.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_butterflies_2(this: IMayaAngelouStoryLayout_ang_springs_butterflies_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_butterflies_2.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_butterflies_1(this: IMayaAngelouStoryLayout_ang_springs_butterflies_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_butterflies_1.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_paperLayer(this: IMayaAngelouStoryLayout_paperLayer) {
	return this;
}
function MayaAngelouStoryLayout_drzWings(this: IMayaAngelouStoryLayout_drzWings) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate yoyo time=4 delay=0.4","isButton":false,"option":"wings"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_wings_drz.call(items[0] as IMayaAngelouStoryLayout_ang_wings_drz);
		(items[0] as IMayaAngelouStoryLayout_ang_wings_drz).animation = "rotate yoyo time=4 delay=0.4";
		(items[0] as IMayaAngelouStoryLayout_ang_wings_drz).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_wings_drz).option = "wings";
		items[0].x = 0;
		items[0].y = 0;
		items[0].rotation = -0.1745;
		items[0].width = 1605.98;
		items[0].height = 750.99;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_wings_drz(this: IMayaAngelouStoryLayout_ang_wings_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_wings_drz.png", 0.598, 0.437);
	return this;
}
function MayaAngelouStoryLayout_ang_springs_drz(this: IMayaAngelouStoryLayout_ang_springs_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzSprings.call(items[0] as IMayaAngelouStoryLayout_buttonDrzSprings);
		items[0].x = -65.5;
		items[0].y = -272;
		items[0].width = 527.00;
		items[0].height = 544.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSprings(this: IMayaAngelouStoryLayout_buttonDrzSprings) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_springs_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_onionrings(this: IMayaAngelouStoryLayout_ang_onionrings) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_onionrings.png", 0.400, 0.744);
	return this;
}
function MayaAngelouStoryLayout_ang_onionrings_drz(this: IMayaAngelouStoryLayout_ang_onionrings_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzRings.call(items[0] as IMayaAngelouStoryLayout_buttonDrzRings);
		items[0].x = 0;
		items[0].y = -177;
		items[0].width = 502.00;
		items[0].height = 354.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzRings(this: IMayaAngelouStoryLayout_buttonDrzRings) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_onionrings_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSwings1(this: IMayaAngelouStoryLayout_buttonDrzSwings1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"swings"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_swing_bg.call(items[0] as IMayaAngelouStoryLayout_ang_swing_bg);
		(items[0] as IMayaAngelouStoryLayout_ang_swing_bg).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_swing_bg).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_swing_bg).option = "swings";
		items[0].x = 0;
		items[0].y = 494;
		items[0].width = 1732.00;
		items[0].height = 988.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"scaleUp 0.9 0.8 time=0.8","isButton":false,"option":"swings"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_swing_drz.call(items[1] as IMayaAngelouStoryLayout_ang_swing_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_swing_drz).animation = "scaleUp 0.9 0.8 time=0.8";
		(items[1] as IMayaAngelouStoryLayout_ang_swing_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_swing_drz).option = "swings";
		items[1].x = -20;
		items[1].y = -433.5;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_swing_bg(this: IMayaAngelouStoryLayout_ang_swing_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_swing_bg.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_swing_drz(this: IMayaAngelouStoryLayout_ang_swing_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzSwings.call(items[0] as IMayaAngelouStoryLayout_buttonDrzSwings);
		items[0].x = -0.5;
		items[0].y = 0;
		items[0].width = 573.00;
		items[0].height = 800.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSwings(this: IMayaAngelouStoryLayout_buttonDrzSwings) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_swing_drz.png", 0.500, 0.000);
	return this;
}
export function MayaAngelouStoryLayout_scene4Dance(this: IMayaAngelouStoryLayout_scene4Dance) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_dance_stereo.call(items[0] as IMayaAngelouStoryLayout_ang_dance_stereo);
		(items[0] as IMayaAngelouStoryLayout_ang_dance_stereo).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_dance_stereo).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_dance_stereo).option = "";
		items[0].x = 1576;
		items[0].y = 1179.55;
		items[0].width = 401.00;
		items[0].height = 225.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"pulse","isButton":false,"option":""});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_dance_speakerright.call(items[1] as IMayaAngelouStoryLayout_ang_dance_speakerright);
		(items[1] as IMayaAngelouStoryLayout_ang_dance_speakerright).animation = "pulse";
		(items[1] as IMayaAngelouStoryLayout_ang_dance_speakerright).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_dance_speakerright).option = "";
		items[1].x = 1691.6;
		items[1].y = 1109.75;
		items[1].width = 124.00;
		items[1].height = 123.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"pulse","isButton":false,"option":""});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_dance_speakerleft.call(items[2] as IMayaAngelouStoryLayout_ang_dance_speakerleft);
		(items[2] as IMayaAngelouStoryLayout_ang_dance_speakerleft).animation = "pulse";
		(items[2] as IMayaAngelouStoryLayout_ang_dance_speakerleft).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_dance_speakerleft).option = "";
		items[2].x = 1447.7;
		items[2].y = 1110.75;
		items[2].width = 123.00;
		items[2].height = 116.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"particles ang-notes","isButton":false,"option":""});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_notesParticles.call(items[3] as IMayaAngelouStoryLayout_notesParticles);
		(items[3] as IMayaAngelouStoryLayout_notesParticles).animation = "particles ang-notes";
		(items[3] as IMayaAngelouStoryLayout_notesParticles).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_notesParticles).option = "";
		items[3].x = 1399.15;
		items[3].y = 961.55;
		items[3].width = 338.50;
		items[3].height = 57.10;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_paperLayer.call(items[4] as IMayaAngelouStoryLayout_paperLayer);
		(items[4] as IMayaAngelouStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"slideIn left ease=backOut","isButton":true,"option":"balloon"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_drzBallons.call(items[5] as IMayaAngelouStoryLayout_drzBallons);
		(items[5] as IMayaAngelouStoryLayout_drzBallons).animation = "slideIn left ease=backOut";
		(items[5] as IMayaAngelouStoryLayout_drzBallons).isButton = true;
		(items[5] as IMayaAngelouStoryLayout_drzBallons).option = "balloon";
		items[5].x = 886.55;
		items[5].y = 1451.75;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"rotate time=20 delay=0.6","isButton":true,"option":"moon"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_drzMoon.call(items[6] as IMayaAngelouStoryLayout_drzMoon);
		(items[6] as IMayaAngelouStoryLayout_drzMoon).animation = "rotate time=20 delay=0.6";
		(items[6] as IMayaAngelouStoryLayout_drzMoon).isButton = true;
		(items[6] as IMayaAngelouStoryLayout_drzMoon).option = "moon";
		items[6].x = 1013.3;
		items[6].y = 705.9;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"slideIn left ease=backOut","isButton":true,"option":"spoon"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_drzSpoon.call(items[7] as IMayaAngelouStoryLayout_drzSpoon);
		(items[7] as IMayaAngelouStoryLayout_drzSpoon).animation = "slideIn left ease=backOut";
		(items[7] as IMayaAngelouStoryLayout_drzSpoon).isButton = true;
		(items[7] as IMayaAngelouStoryLayout_drzSpoon).option = "spoon";
		items[7].x = 1105.85;
		items[7].y = 754.3;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"dance delay=0.6","isButton":true,"option":"raccoon"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_drzRacoon.call(items[8] as IMayaAngelouStoryLayout_drzRacoon);
		(items[8] as IMayaAngelouStoryLayout_drzRacoon).animation = "dance delay=0.6";
		(items[8] as IMayaAngelouStoryLayout_drzRacoon).isButton = true;
		(items[8] as IMayaAngelouStoryLayout_drzRacoon).option = "raccoon";
		items[8].x = 976.15;
		items[8].y = 1116.55;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_dance_stereo(this: IMayaAngelouStoryLayout_ang_dance_stereo) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_dance_stereo.png", 0.501, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_dance_speakerright(this: IMayaAngelouStoryLayout_ang_dance_speakerright) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_dance_speakerright.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_dance_speakerleft(this: IMayaAngelouStoryLayout_ang_dance_speakerleft) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_dance_speakerleft.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_notesParticles(this: IMayaAngelouStoryLayout_notesParticles) {
	return this;
}
function MayaAngelouStoryLayout_drzBallons(this: IMayaAngelouStoryLayout_drzBallons) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float speed=0.2 time=2","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_drzBalloon1.call(items[0] as IMayaAngelouStoryLayout_drzBalloon1);
		(items[0] as IMayaAngelouStoryLayout_drzBalloon1).animation = "float speed=0.2 time=2";
		(items[0] as IMayaAngelouStoryLayout_drzBalloon1).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_drzBalloon1).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_drzBalloon1(this: IMayaAngelouStoryLayout_drzBalloon1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"balloon"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_balloon.call(items[0] as IMayaAngelouStoryLayout_ang_balloon);
		(items[0] as IMayaAngelouStoryLayout_ang_balloon).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_balloon).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_balloon).option = "balloon";
		items[0].x = 20;
		items[0].y = -67;
		items[0].width = 866.00;
		items[0].height = 1135.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"balloon"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_balloon_drz.call(items[1] as IMayaAngelouStoryLayout_ang_balloon_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_balloon_drz).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_balloon_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_balloon_drz).option = "balloon";
		items[1].x = 19.1;
		items[1].y = -943.35;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_balloon(this: IMayaAngelouStoryLayout_ang_balloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_balloon.png", 0.523, 0.941);
	return this;
}
function MayaAngelouStoryLayout_ang_balloon_drz(this: IMayaAngelouStoryLayout_ang_balloon_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzBalloon.call(items[0] as IMayaAngelouStoryLayout_buttonDrzBalloon);
		items[0].x = 0;
		items[0].y = -0.5;
		items[0].width = 496.00;
		items[0].height = 423.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzBalloon(this: IMayaAngelouStoryLayout_buttonDrzBalloon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_balloon_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzMoon(this: IMayaAngelouStoryLayout_drzMoon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"scaleUp ease=backOut time=0.6","isButton":false,"option":"moon"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_moon.call(items[0] as IMayaAngelouStoryLayout_ang_moon);
		(items[0] as IMayaAngelouStoryLayout_ang_moon).animation = "scaleUp ease=backOut time=0.6";
		(items[0] as IMayaAngelouStoryLayout_ang_moon).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_moon).option = "moon";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 641.00;
		items[0].height = 641.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch delay=0.4 appear","isButton":false,"option":"moon"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_moon_drz.call(items[1] as IMayaAngelouStoryLayout_ang_moon_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_moon_drz).animation = "squishStretch delay=0.4 appear";
		(items[1] as IMayaAngelouStoryLayout_ang_moon_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_moon_drz).option = "moon";
		items[1].x = -47.85;
		items[1].y = -297.3;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_moon(this: IMayaAngelouStoryLayout_ang_moon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_moon.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_moon_drz(this: IMayaAngelouStoryLayout_ang_moon_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzMoon.call(items[0] as IMayaAngelouStoryLayout_buttonDrzMoon);
		items[0].x = 1;
		items[0].y = -65.5;
		items[0].width = 310.00;
		items[0].height = 279.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzMoon(this: IMayaAngelouStoryLayout_buttonDrzMoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_moon_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzSpoon(this: IMayaAngelouStoryLayout_drzSpoon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"dance delay=0.6","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_drzSpoonDance.call(items[0] as IMayaAngelouStoryLayout_drzSpoonDance);
		(items[0] as IMayaAngelouStoryLayout_drzSpoonDance).animation = "dance delay=0.6";
		(items[0] as IMayaAngelouStoryLayout_drzSpoonDance).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_drzSpoonDance).option = "";
		items[0].x = -148.8;
		items[0].y = 91.45;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_drzSpoonDance(this: IMayaAngelouStoryLayout_drzSpoonDance) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"spoon"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_spoon.call(items[0] as IMayaAngelouStoryLayout_ang_spoon);
		(items[0] as IMayaAngelouStoryLayout_ang_spoon).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_spoon).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_spoon).option = "spoon";
		items[0].x = 175.9;
		items[0].y = -92.4;
		items[0].width = 788.00;
		items[0].height = 453.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"spoon"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_spoon_drz.call(items[1] as IMayaAngelouStoryLayout_ang_spoon_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_spoon_drz).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_spoon_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_spoon_drz).option = "spoon";
		items[1].x = -75;
		items[1].y = -109.2;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_spoon(this: IMayaAngelouStoryLayout_ang_spoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_spoon.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_spoon_drz(this: IMayaAngelouStoryLayout_ang_spoon_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzSpoon.call(items[0] as IMayaAngelouStoryLayout_buttonDrzSpoon);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 395.00;
		items[0].height = 371.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSpoon(this: IMayaAngelouStoryLayout_buttonDrzSpoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_spoon_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzRacoon(this: IMayaAngelouStoryLayout_drzRacoon) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch delay=0.2 appear","isButton":false,"option":"raccoon"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_raccoon_drz.call(items[0] as IMayaAngelouStoryLayout_ang_raccoon_drz);
		(items[0] as IMayaAngelouStoryLayout_ang_raccoon_drz).animation = "squishStretch delay=0.2 appear";
		(items[0] as IMayaAngelouStoryLayout_ang_raccoon_drz).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_raccoon_drz).option = "raccoon";
		items[0].x = 7.75;
		items[0].y = -551.05;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":false,"option":"raccoon"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_raccoon.call(items[1] as IMayaAngelouStoryLayout_ang_raccoon);
		(items[1] as IMayaAngelouStoryLayout_ang_raccoon).animation = "squishStretch";
		(items[1] as IMayaAngelouStoryLayout_ang_raccoon).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_raccoon).option = "raccoon";
		items[1].x = 48.55;
		items[1].y = 43.2;
		items[1].width = 520.00;
		items[1].height = 696.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch delay=0.2 appear","isButton":false,"option":"raccoon"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_raccoon_drz_front.call(items[2] as IMayaAngelouStoryLayout_ang_raccoon_drz_front);
		(items[2] as IMayaAngelouStoryLayout_ang_raccoon_drz_front).animation = "squishStretch delay=0.2 appear";
		(items[2] as IMayaAngelouStoryLayout_ang_raccoon_drz_front).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_raccoon_drz_front).option = "raccoon";
		items[2].x = 7.75;
		items[2].y = -551.05;
		items[2].width = 511.00;
		items[2].height = 515.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_raccoon_drz(this: IMayaAngelouStoryLayout_ang_raccoon_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzRaccoon.call(items[0] as IMayaAngelouStoryLayout_buttonDrzRaccoon);
		items[0].x = -0.5;
		items[0].y = -135.5;
		items[0].width = 511.00;
		items[0].height = 515.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzRaccoon(this: IMayaAngelouStoryLayout_buttonDrzRaccoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_raccoon(this: IMayaAngelouStoryLayout_ang_raccoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_raccoon_drz_front(this: IMayaAngelouStoryLayout_ang_raccoon_drz_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_raccoon_drz_front.png", 0.501, 0.763);
	return this;
}
export function MayaAngelouStoryLayout_scene5Power(this: IMayaAngelouStoryLayout_scene5Power) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch delay=0.2 appear","isButton":false,"option":"tower"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_pizzatower_left.call(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_left);
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_left).animation = "squishStretch delay=0.2 appear";
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_left).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_left).option = "tower";
		items[0].x = 682.9;
		items[0].y = 1059.45;
		items[0].width = 895.00;
		items[0].height = 663.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":false,"option":"hour"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_sittingstill.call(items[1] as IMayaAngelouStoryLayout_ang_sittingstill);
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill).animation = "squishStretch";
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill).option = "hour";
		items[1].x = 1024.65;
		items[1].y = 1115.2;
		items[1].width = 1686.00;
		items[1].height = 722.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"shower"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_buttonDrzShower1.call(items[2] as IMayaAngelouStoryLayout_buttonDrzShower1);
		(items[2] as IMayaAngelouStoryLayout_buttonDrzShower1).animation = "";
		(items[2] as IMayaAngelouStoryLayout_buttonDrzShower1).isButton = true;
		(items[2] as IMayaAngelouStoryLayout_buttonDrzShower1).option = "shower";
		items[2].x = 1045.25;
		items[2].y = 1247.25;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"slideIn right delay=1 time=0.6","isButton":false,"option":"flower"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_ang_flower_right.call(items[3] as IMayaAngelouStoryLayout_ang_flower_right);
		(items[3] as IMayaAngelouStoryLayout_ang_flower_right).animation = "slideIn right delay=1 time=0.6";
		(items[3] as IMayaAngelouStoryLayout_ang_flower_right).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_ang_flower_right).option = "flower";
		items[3].x = 1468.6;
		items[3].y = 953.65;
		items[3].width = 679.00;
		items[3].height = 737.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"slideIn left delay=0.6 time=0.6","isButton":false,"option":"flower"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_ang_flower_left.call(items[4] as IMayaAngelouStoryLayout_ang_flower_left);
		(items[4] as IMayaAngelouStoryLayout_ang_flower_left).animation = "slideIn left delay=0.6 time=0.6";
		(items[4] as IMayaAngelouStoryLayout_ang_flower_left).isButton = false;
		(items[4] as IMayaAngelouStoryLayout_ang_flower_left).option = "flower";
		items[4].x = 772;
		items[4].y = 868.6;
		items[4].width = 551.00;
		items[4].height = 620.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":false,"option":"flower"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_flower.call(items[5] as IMayaAngelouStoryLayout_ang_flower);
		(items[5] as IMayaAngelouStoryLayout_ang_flower).animation = "squishStretch";
		(items[5] as IMayaAngelouStoryLayout_ang_flower).isButton = false;
		(items[5] as IMayaAngelouStoryLayout_ang_flower).option = "flower";
		items[5].x = 1239.2;
		items[5].y = 1073.6;
		items[5].width = 332.00;
		items[5].height = 403.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch delay=0.4 appear","isButton":true,"option":"flower"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_flower_drz.call(items[6] as IMayaAngelouStoryLayout_ang_flower_drz);
		(items[6] as IMayaAngelouStoryLayout_ang_flower_drz).animation = "squishStretch delay=0.4 appear";
		(items[6] as IMayaAngelouStoryLayout_ang_flower_drz).isButton = true;
		(items[6] as IMayaAngelouStoryLayout_ang_flower_drz).option = "flower";
		items[6].x = 1042.6;
		items[6].y = 1069.55;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":false,"option":"tower"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_drzTower.call(items[7] as IMayaAngelouStoryLayout_drzTower);
		(items[7] as IMayaAngelouStoryLayout_drzTower).animation = "squishStretch";
		(items[7] as IMayaAngelouStoryLayout_drzTower).isButton = false;
		(items[7] as IMayaAngelouStoryLayout_drzTower).option = "tower";
		items[7].x = 1208.75;
		items[7].y = 1121.95;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch delay=0.4 appear","isButton":true,"option":"hour"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_sittingstill_drz.call(items[8] as IMayaAngelouStoryLayout_ang_sittingstill_drz);
		(items[8] as IMayaAngelouStoryLayout_ang_sittingstill_drz).animation = "squishStretch delay=0.4 appear";
		(items[8] as IMayaAngelouStoryLayout_ang_sittingstill_drz).isButton = true;
		(items[8] as IMayaAngelouStoryLayout_ang_sittingstill_drz).option = "hour";
		items[8].x = 1191.6;
		items[8].y = 771.25;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"scaleUp","isButton":false,"option":"hour"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_clock.call(items[9] as IMayaAngelouStoryLayout_clock);
		(items[9] as IMayaAngelouStoryLayout_clock).animation = "scaleUp";
		(items[9] as IMayaAngelouStoryLayout_clock).isButton = false;
		(items[9] as IMayaAngelouStoryLayout_clock).option = "hour";
		items[9].x = 786.35;
		items[9].y = 318.4;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"isPaperLayer":true});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_paperLayer.call(items[10] as IMayaAngelouStoryLayout_paperLayer);
		(items[10] as IMayaAngelouStoryLayout_paperLayer).isPaperLayer = true;
		items[10].x = 0;
		items[10].y = 0;
		items[10].width = 2048.00;
		items[10].height = 1536.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"squishStretch delay=0.8 appear","isButton":true,"option":"tower"});
	}
	if (items[11]) {
		MayaAngelouStoryLayout_ang_pizzatower_brad.call(items[11] as IMayaAngelouStoryLayout_ang_pizzatower_brad);
		(items[11] as IMayaAngelouStoryLayout_ang_pizzatower_brad).animation = "squishStretch delay=0.8 appear";
		(items[11] as IMayaAngelouStoryLayout_ang_pizzatower_brad).isButton = true;
		(items[11] as IMayaAngelouStoryLayout_ang_pizzatower_brad).option = "tower";
		items[11].x = 1770.85;
		items[11].y = 1162.85;
		items[11].width = 294.00;
		items[11].height = 493.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"squishStretch delay=0.6 appear","isButton":true,"option":"tower"});
	}
	if (items[12]) {
		MayaAngelouStoryLayout_ang_pizzatower__xavier.call(items[12] as IMayaAngelouStoryLayout_ang_pizzatower__xavier);
		(items[12] as IMayaAngelouStoryLayout_ang_pizzatower__xavier).animation = "squishStretch delay=0.6 appear";
		(items[12] as IMayaAngelouStoryLayout_ang_pizzatower__xavier).isButton = true;
		(items[12] as IMayaAngelouStoryLayout_ang_pizzatower__xavier).option = "tower";
		items[12].x = 305;
		items[12].y = 1157.35;
		items[12].width = 301.00;
		items[12].height = 511.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"squishStretch delay=0.7 appear","isButton":true,"option":"tower"});
	}
	if (items[13]) {
		MayaAngelouStoryLayout_ang_pizzatower_yadina.call(items[13] as IMayaAngelouStoryLayout_ang_pizzatower_yadina);
		(items[13] as IMayaAngelouStoryLayout_ang_pizzatower_yadina).animation = "squishStretch delay=0.7 appear";
		(items[13] as IMayaAngelouStoryLayout_ang_pizzatower_yadina).isButton = true;
		(items[13] as IMayaAngelouStoryLayout_ang_pizzatower_yadina).option = "tower";
		items[13].x = 675.45;
		items[13].y = 1059.8;
		items[13].width = 400.00;
		items[13].height = 455.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower_left(this: IMayaAngelouStoryLayout_ang_pizzatower_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_left.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_sittingstill(this: IMayaAngelouStoryLayout_ang_sittingstill) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill.png", 0.500, 0.848);
	return this;
}
function MayaAngelouStoryLayout_buttonDrzShower1(this: IMayaAngelouStoryLayout_buttonDrzShower1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch delay=0.4 appear","isButton":false,"option":"shower"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_shower_dzr.call(items[0] as IMayaAngelouStoryLayout_ang_shower_dzr);
		(items[0] as IMayaAngelouStoryLayout_ang_shower_dzr).animation = "squishStretch delay=0.4 appear";
		(items[0] as IMayaAngelouStoryLayout_ang_shower_dzr).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_shower_dzr).option = "shower";
		items[0].x = 324.8;
		items[0].y = -377.15;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch","isButton":false,"option":"shower"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_shower.call(items[1] as IMayaAngelouStoryLayout_ang_shower);
		(items[1] as IMayaAngelouStoryLayout_ang_shower).animation = "squishStretch";
		(items[1] as IMayaAngelouStoryLayout_ang_shower).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_shower).option = "shower";
		items[1].x = -17.5;
		items[1].y = -61;
		items[1].width = 995.00;
		items[1].height = 1023.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch delay=0.4 appear","isButton":false,"option":"shower"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_shower_dzr_front.call(items[2] as IMayaAngelouStoryLayout_ang_shower_dzr_front);
		(items[2] as IMayaAngelouStoryLayout_ang_shower_dzr_front).animation = "squishStretch delay=0.4 appear";
		(items[2] as IMayaAngelouStoryLayout_ang_shower_dzr_front).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_shower_dzr_front).option = "shower";
		items[2].x = 319.3;
		items[2].y = -374.65;
		items[2].width = 86.00;
		items[2].height = 67.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"particles ang-notes speed=0.3 delay=0.6","isButton":false,"option":"shower"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_notesParticles.call(items[3] as IMayaAngelouStoryLayout_notesParticles);
		(items[3] as IMayaAngelouStoryLayout_notesParticles).animation = "particles ang-notes speed=0.3 delay=0.6";
		(items[3] as IMayaAngelouStoryLayout_notesParticles).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_notesParticles).option = "shower";
		items[3].x = 363.3;
		items[3].y = -602;
		items[3].width = 152.25;
		items[3].height = 57.10;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_shower_dzr(this: IMayaAngelouStoryLayout_ang_shower_dzr) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzShower.call(items[0] as IMayaAngelouStoryLayout_buttonDrzShower);
		items[0].x = -10;
		items[0].y = -54.5;
		items[0].width = 296.00;
		items[0].height = 207.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzShower(this: IMayaAngelouStoryLayout_buttonDrzShower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_dzr.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_shower(this: IMayaAngelouStoryLayout_ang_shower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower.png", 0.501, 0.940);
	return this;
}
function MayaAngelouStoryLayout_ang_shower_dzr_front(this: IMayaAngelouStoryLayout_ang_shower_dzr_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_shower_dzr_front.png", 0.919, 0.224);
	return this;
}
function MayaAngelouStoryLayout_ang_flower_right(this: IMayaAngelouStoryLayout_ang_flower_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_right.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_flower_left(this: IMayaAngelouStoryLayout_ang_flower_left) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_left.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_flower(this: IMayaAngelouStoryLayout_ang_flower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_flower_drz(this: IMayaAngelouStoryLayout_ang_flower_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzFlower.call(items[0] as IMayaAngelouStoryLayout_buttonDrzFlower);
		items[0].x = -0.5;
		items[0].y = -97.5;
		items[0].width = 393.00;
		items[0].height = 373.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzFlower(this: IMayaAngelouStoryLayout_buttonDrzFlower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_flower_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzTower(this: IMayaAngelouStoryLayout_drzTower) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_pizzatower_right.call(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_right);
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_right).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_right).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_pizzatower_right).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 994.00;
		items[0].height = 736.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch delay=0.4 appear","isButton":true,"option":"tower"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_pizzatower_drz.call(items[1] as IMayaAngelouStoryLayout_ang_pizzatower_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_pizzatower_drz).animation = "squishStretch delay=0.4 appear";
		(items[1] as IMayaAngelouStoryLayout_ang_pizzatower_drz).isButton = true;
		(items[1] as IMayaAngelouStoryLayout_ang_pizzatower_drz).option = "tower";
		items[1].x = -50.85;
		items[1].y = -498.15;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower_right(this: IMayaAngelouStoryLayout_ang_pizzatower_right) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_right.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower_drz(this: IMayaAngelouStoryLayout_ang_pizzatower_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzTower.call(items[0] as IMayaAngelouStoryLayout_buttonDrzTower);
		items[0].x = 0;
		items[0].y = -83.5;
		items[0].width = 236.00;
		items[0].height = 213.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzTower(this: IMayaAngelouStoryLayout_buttonDrzTower) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sittingstill_drz(this: IMayaAngelouStoryLayout_ang_sittingstill_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzHour.call(items[0] as IMayaAngelouStoryLayout_buttonDrzHour);
		items[0].x = 0;
		items[0].y = -107;
		items[0].width = 216.00;
		items[0].height = 274.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzHour(this: IMayaAngelouStoryLayout_buttonDrzHour) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_clock(this: IMayaAngelouStoryLayout_clock) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sittingstill_clock.call(items[0] as IMayaAngelouStoryLayout_ang_sittingstill_clock);
		(items[0] as IMayaAngelouStoryLayout_ang_sittingstill_clock).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_sittingstill_clock).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sittingstill_clock).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 294.00;
		items[0].height = 286.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"rotate time=4 repeat=0.1 delay=0.4","isButton":false,"option":""});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_sittingstill_clock_handMin.call(items[1] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin);
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin).animation = "rotate time=4 repeat=0.1 delay=0.4";
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin).option = "";
		items[1].x = 0;
		items[1].y = 0;
		items[1].width = 6.00;
		items[1].height = 71.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"rotate 0 time=4 repeat=0.1 delay=0.4","isButton":false,"option":""});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_sittingstill_clock_handHr.call(items[2] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr);
		(items[2] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr).animation = "rotate 0 time=4 repeat=0.1 delay=0.4";
		(items[2] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr).option = "";
		items[2].x = 0;
		items[2].y = 0;
		items[2].rotation = -0.5361;
		items[2].width = 6.00;
		items[2].height = 46.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sittingstill_clock(this: IMayaAngelouStoryLayout_ang_sittingstill_clock) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sittingstill_clock_handMin(this: IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock_hand-min.png", 0.500, 0.972);
	return this;
}
function MayaAngelouStoryLayout_ang_sittingstill_clock_handHr(this: IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sittingstill_clock_hand-hr.png", 0.500, 0.957);
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower_brad(this: IMayaAngelouStoryLayout_ang_pizzatower_brad) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_brad.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower__xavier(this: IMayaAngelouStoryLayout_ang_pizzatower__xavier) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower__xavier.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_pizzatower_yadina(this: IMayaAngelouStoryLayout_ang_pizzatower_yadina) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pizzatower_yadina.png", 0.500, 1.000);
	return this;
}
export function MayaAngelouStoryLayout_scene6Bed(this: IMayaAngelouStoryLayout_scene6Bed) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"sled"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sled_pillow_back.call(items[0] as IMayaAngelouStoryLayout_ang_sled_pillow_back);
		(items[0] as IMayaAngelouStoryLayout_ang_sled_pillow_back).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_sled_pillow_back).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sled_pillow_back).option = "sled";
		items[0].x = 1103.35;
		items[0].y = 773.05;
		items[0].width = 1666.00;
		items[0].height = 285.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"bread"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_sled_pillow_back.call(items[1] as IMayaAngelouStoryLayout_ang_sled_pillow_back);
		(items[1] as IMayaAngelouStoryLayout_ang_sled_pillow_back).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_sled_pillow_back).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_sled_pillow_back).option = "bread";
		items[1].x = 1103.35;
		items[1].y = 773.05;
		items[1].width = 1666.00;
		items[1].height = 285.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"fred"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_sled_pillow_back.call(items[2] as IMayaAngelouStoryLayout_ang_sled_pillow_back);
		(items[2] as IMayaAngelouStoryLayout_ang_sled_pillow_back).animation = "";
		(items[2] as IMayaAngelouStoryLayout_ang_sled_pillow_back).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_sled_pillow_back).option = "fred";
		items[2].x = 1103.35;
		items[2].y = 705.05;
		items[2].width = 1666.00;
		items[2].height = 285.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"isPaperLayer":true});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_paperLayer.call(items[3] as IMayaAngelouStoryLayout_paperLayer);
		(items[3] as IMayaAngelouStoryLayout_paperLayer).isPaperLayer = true;
		items[3].x = 0;
		items[3].y = 0;
		items[3].width = 2048.00;
		items[3].height = 1536.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"slideIn left time=1","isButton":false,"option":"sled"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_drzSled.call(items[4] as IMayaAngelouStoryLayout_drzSled);
		(items[4] as IMayaAngelouStoryLayout_drzSled).animation = "slideIn left time=1";
		(items[4] as IMayaAngelouStoryLayout_drzSled).isButton = false;
		(items[4] as IMayaAngelouStoryLayout_drzSled).option = "sled";
		items[4].x = 1166.25;
		items[4].y = 1002.85;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"drop","isButton":false,"option":"bread"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_bread.call(items[5] as IMayaAngelouStoryLayout_ang_bread);
		(items[5] as IMayaAngelouStoryLayout_ang_bread).animation = "drop";
		(items[5] as IMayaAngelouStoryLayout_ang_bread).isButton = false;
		(items[5] as IMayaAngelouStoryLayout_ang_bread).option = "bread";
		items[5].x = 1064.3;
		items[5].y = 972.2;
		items[5].width = 566.00;
		items[5].height = 250.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"drop delay=0.2 appear","isButton":true,"option":"bread"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_bread_drz.call(items[6] as IMayaAngelouStoryLayout_ang_bread_drz);
		(items[6] as IMayaAngelouStoryLayout_ang_bread_drz).animation = "drop delay=0.2 appear";
		(items[6] as IMayaAngelouStoryLayout_ang_bread_drz).isButton = true;
		(items[6] as IMayaAngelouStoryLayout_ang_bread_drz).option = "bread";
		items[6].x = 1066;
		items[6].y = 972.7;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":true,"option":"head"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_drzBed.call(items[7] as IMayaAngelouStoryLayout_drzBed);
		(items[7] as IMayaAngelouStoryLayout_drzBed).animation = "squishStretch";
		(items[7] as IMayaAngelouStoryLayout_drzBed).isButton = true;
		(items[7] as IMayaAngelouStoryLayout_drzBed).option = "head";
		items[7].x = 1023.8;
		items[7].y = 1076.8;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"drop","isButton":false,"option":"fred"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_pillow.call(items[8] as IMayaAngelouStoryLayout_ang_pillow);
		(items[8] as IMayaAngelouStoryLayout_ang_pillow).animation = "drop";
		(items[8] as IMayaAngelouStoryLayout_ang_pillow).isButton = false;
		(items[8] as IMayaAngelouStoryLayout_ang_pillow).option = "fred";
		items[8].x = 1057.2;
		items[8].y = 1104.05;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":false,"option":"sled"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_ang_sled_pillow_front.call(items[9] as IMayaAngelouStoryLayout_ang_sled_pillow_front);
		(items[9] as IMayaAngelouStoryLayout_ang_sled_pillow_front).animation = "";
		(items[9] as IMayaAngelouStoryLayout_ang_sled_pillow_front).isButton = false;
		(items[9] as IMayaAngelouStoryLayout_ang_sled_pillow_front).option = "sled";
		items[9].x = 328.25;
		items[9].y = 1008;
		items[9].width = 573.00;
		items[9].height = 323.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":false,"option":"bread"});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_ang_sled_pillow_front.call(items[10] as IMayaAngelouStoryLayout_ang_sled_pillow_front);
		(items[10] as IMayaAngelouStoryLayout_ang_sled_pillow_front).animation = "";
		(items[10] as IMayaAngelouStoryLayout_ang_sled_pillow_front).isButton = false;
		(items[10] as IMayaAngelouStoryLayout_ang_sled_pillow_front).option = "bread";
		items[10].x = 328.25;
		items[10].y = 1008;
		items[10].width = 573.00;
		items[10].height = 323.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"particles ang-sleep delay=0.6","isButton":false,"option":"head"});
	}
	if (items[11]) {
		MayaAngelouStoryLayout_notesParticles.call(items[11] as IMayaAngelouStoryLayout_notesParticles);
		(items[11] as IMayaAngelouStoryLayout_notesParticles).animation = "particles ang-sleep delay=0.6";
		(items[11] as IMayaAngelouStoryLayout_notesParticles).isButton = false;
		(items[11] as IMayaAngelouStoryLayout_notesParticles).option = "head";
		items[11].x = 1182.05;
		items[11].y = 399.45;
		items[11].width = 74.70;
		items[11].height = 57.10;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"","isButton":false,"option":"fred"});
	}
	if (items[12]) {
		MayaAngelouStoryLayout_ang_sled_pillow_front.call(items[12] as IMayaAngelouStoryLayout_ang_sled_pillow_front);
		(items[12] as IMayaAngelouStoryLayout_ang_sled_pillow_front).animation = "";
		(items[12] as IMayaAngelouStoryLayout_ang_sled_pillow_front).isButton = false;
		(items[12] as IMayaAngelouStoryLayout_ang_sled_pillow_front).option = "fred";
		items[12].x = 328.25;
		items[12].y = 940;
		items[12].width = 573.00;
		items[12].height = 323.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"drop delay=0.2 appear","isButton":true,"option":"fred"});
	}
	if (items[13]) {
		MayaAngelouStoryLayout_ang_pillow_drz.call(items[13] as IMayaAngelouStoryLayout_ang_pillow_drz);
		(items[13] as IMayaAngelouStoryLayout_ang_pillow_drz).animation = "drop delay=0.2 appear";
		(items[13] as IMayaAngelouStoryLayout_ang_pillow_drz).isButton = true;
		(items[13] as IMayaAngelouStoryLayout_ang_pillow_drz).option = "fred";
		items[13].x = 1023.65;
		items[13].y = 1009.6;
		if (items[13].onLayout) items[13].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sled_pillow_back(this: IMayaAngelouStoryLayout_ang_sled_pillow_back) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_pillow_back.png", 0.500, 0.502);
	return this;
}
function MayaAngelouStoryLayout_drzSled(this: IMayaAngelouStoryLayout_drzSled) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"sled"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sled.call(items[0] as IMayaAngelouStoryLayout_ang_sled);
		(items[0] as IMayaAngelouStoryLayout_ang_sled).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_sled).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sled).option = "sled";
		items[0].x = 0;
		items[0].y = -0.5;
		items[0].width = 1126.00;
		items[0].height = 267.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"sled"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_sled_drz.call(items[1] as IMayaAngelouStoryLayout_ang_sled_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_sled_drz).animation = "";
		(items[1] as IMayaAngelouStoryLayout_ang_sled_drz).isButton = true;
		(items[1] as IMayaAngelouStoryLayout_ang_sled_drz).option = "sled";
		items[1].x = -64.7;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sled(this: IMayaAngelouStoryLayout_ang_sled) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_sled_drz(this: IMayaAngelouStoryLayout_ang_sled_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzSled.call(items[0] as IMayaAngelouStoryLayout_buttonDrzSled);
		items[0].x = -0.5;
		items[0].y = -195;
		items[0].width = 389.00;
		items[0].height = 390.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzSled(this: IMayaAngelouStoryLayout_buttonDrzSled) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_bread(this: IMayaAngelouStoryLayout_ang_bread) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_bread.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_bread_drz(this: IMayaAngelouStoryLayout_ang_bread_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzBread.call(items[0] as IMayaAngelouStoryLayout_buttonDrzBread);
		items[0].x = -0.5;
		items[0].y = -171;
		items[0].width = 383.00;
		items[0].height = 342.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzBread(this: IMayaAngelouStoryLayout_buttonDrzBread) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_bread_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_drzBed(this: IMayaAngelouStoryLayout_drzBed) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"head"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_sleepyhead_bed.call(items[0] as IMayaAngelouStoryLayout_ang_sleepyhead_bed);
		(items[0] as IMayaAngelouStoryLayout_ang_sleepyhead_bed).animation = "";
		(items[0] as IMayaAngelouStoryLayout_ang_sleepyhead_bed).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_sleepyhead_bed).option = "head";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 980.00;
		items[0].height = 418.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch delay=0.4 appear","isButton":false,"option":"head"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_sleepyhead_drz.call(items[1] as IMayaAngelouStoryLayout_ang_sleepyhead_drz);
		(items[1] as IMayaAngelouStoryLayout_ang_sleepyhead_drz).animation = "squishStretch delay=0.4 appear";
		(items[1] as IMayaAngelouStoryLayout_ang_sleepyhead_drz).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_sleepyhead_drz).option = "head";
		items[1].x = 73.85;
		items[1].y = -235.45;
		items[1].width = 510.00;
		items[1].height = 653.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_sleepyhead_bed(this: IMayaAngelouStoryLayout_ang_sleepyhead_bed) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_bed.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_ang_sleepyhead_drz(this: IMayaAngelouStoryLayout_ang_sleepyhead_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sleepyhead_drz.png", 0.598, 0.908);
	return this;
}
function MayaAngelouStoryLayout_ang_pillow(this: IMayaAngelouStoryLayout_ang_pillow) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"to pillowBounce time=0.15 delay=0.5 ease=sineInOut repeat=1 yoyo","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_pillowBounce.call(items[0] as IMayaAngelouStoryLayout_pillowBounce);
		(items[0] as IMayaAngelouStoryLayout_pillowBounce).animation = "to pillowBounce time=0.15 delay=0.5 ease=sineInOut repeat=1 yoyo";
		(items[0] as IMayaAngelouStoryLayout_pillowBounce).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_pillowBounce).option = "";
		items[0].x = -0.5;
		items[0].y = -259;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"hide id=pillowBounce","isButton":false,"option":""});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_pillowBounce.call(items[1] as IMayaAngelouStoryLayout_pillowBounce);
		(items[1] as IMayaAngelouStoryLayout_pillowBounce).animation = "hide id=pillowBounce";
		(items[1] as IMayaAngelouStoryLayout_pillowBounce).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_pillowBounce).option = "";
		items[1].x = -0.5;
		items[1].y = -235.65;
		if (items[1].scale) items[1].scale.y = 0.863;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_pillowBounce(this: IMayaAngelouStoryLayout_pillowBounce) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_pillowInner.call(items[0] as IMayaAngelouStoryLayout_pillowInner);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 823.00;
		items[0].height = 518.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_pillowInner(this: IMayaAngelouStoryLayout_pillowInner) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pillow.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_sled_pillow_front(this: IMayaAngelouStoryLayout_ang_sled_pillow_front) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_sled_pillow_front.png", 0.501, 0.502);
	return this;
}
function MayaAngelouStoryLayout_ang_pillow_drz(this: IMayaAngelouStoryLayout_ang_pillow_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"hide id=drzPillowBounce","isButton":false,"option":""});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_drzPillowBounce.call(items[0] as IMayaAngelouStoryLayout_drzPillowBounce);
		(items[0] as IMayaAngelouStoryLayout_drzPillowBounce).animation = "hide id=drzPillowBounce";
		(items[0] as IMayaAngelouStoryLayout_drzPillowBounce).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_drzPillowBounce).option = "";
		items[0].x = -0.5;
		items[0].y = -161.1;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"to drzPillowBounce time=0.15 delay=0.5 ease=sineInOut repeat=1 yoyo","isButton":false,"option":""});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_drzPillowBounce.call(items[1] as IMayaAngelouStoryLayout_drzPillowBounce);
		(items[1] as IMayaAngelouStoryLayout_drzPillowBounce).animation = "to drzPillowBounce time=0.15 delay=0.5 ease=sineInOut repeat=1 yoyo";
		(items[1] as IMayaAngelouStoryLayout_drzPillowBounce).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_drzPillowBounce).option = "";
		items[1].x = -0.5;
		items[1].y = -190.5;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_drzPillowBounce(this: IMayaAngelouStoryLayout_drzPillowBounce) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzPillow.call(items[0] as IMayaAngelouStoryLayout_buttonDrzPillow);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 479.00;
		items[0].height = 381.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzPillow(this: IMayaAngelouStoryLayout_buttonDrzPillow) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_pillow_drz.png", 0.500, 0.500);
	return this;
}
export function MayaAngelouStoryLayout_scene7End(this: IMayaAngelouStoryLayout_scene7End) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"hide id=icecreamHeart","isButton":false,"option":"anyone"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_afriend_hearts.call(items[0] as IMayaAngelouStoryLayout_ang_afriend_hearts);
		(items[0] as IMayaAngelouStoryLayout_ang_afriend_hearts).animation = "hide id=icecreamHeart";
		(items[0] as IMayaAngelouStoryLayout_ang_afriend_hearts).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_afriend_hearts).option = "anyone";
		items[0].x = 1084.5;
		items[0].y = 1010.25;
		items[0].width = 78.50;
		items[0].height = 62.63;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"from icecreamHeart time=0.8 bezier appear ease=backOut delay=1.1","isButton":false,"option":"anyone"});
	}
	if (items[1]) {
		MayaAngelouStoryLayout_ang_afriend_hearts.call(items[1] as IMayaAngelouStoryLayout_ang_afriend_hearts);
		(items[1] as IMayaAngelouStoryLayout_ang_afriend_hearts).animation = "from icecreamHeart time=0.8 bezier appear ease=backOut delay=1.1";
		(items[1] as IMayaAngelouStoryLayout_ang_afriend_hearts).isButton = false;
		(items[1] as IMayaAngelouStoryLayout_ang_afriend_hearts).option = "anyone";
		items[1].x = 1247.3;
		items[1].y = 352.7;
		items[1].rotation = 0.3803;
		items[1].width = 106.43;
		items[1].height = 84.91;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"from icecreamHeart time=0.8 bezier appear ease=backOut delay=1","isButton":false,"option":"anyone"});
	}
	if (items[2]) {
		MayaAngelouStoryLayout_ang_afriend_hearts.call(items[2] as IMayaAngelouStoryLayout_ang_afriend_hearts);
		(items[2] as IMayaAngelouStoryLayout_ang_afriend_hearts).animation = "from icecreamHeart time=0.8 bezier appear ease=backOut delay=1";
		(items[2] as IMayaAngelouStoryLayout_ang_afriend_hearts).isButton = false;
		(items[2] as IMayaAngelouStoryLayout_ang_afriend_hearts).option = "anyone";
		items[2].x = 864.8;
		items[2].y = 395.35;
		items[2].rotation = -0.1439;
		items[2].width = 132.59;
		items[2].height = 105.78;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"from icecreamHeart time=0.8 bezier appear ease=backOut delay=0.9","isButton":false,"option":"anyone"});
	}
	if (items[3]) {
		MayaAngelouStoryLayout_ang_afriend_hearts.call(items[3] as IMayaAngelouStoryLayout_ang_afriend_hearts);
		(items[3] as IMayaAngelouStoryLayout_ang_afriend_hearts).animation = "from icecreamHeart time=0.8 bezier appear ease=backOut delay=0.9";
		(items[3] as IMayaAngelouStoryLayout_ang_afriend_hearts).isButton = false;
		(items[3] as IMayaAngelouStoryLayout_ang_afriend_hearts).option = "anyone";
		items[3].x = 780.25;
		items[3].y = 599.7;
		items[3].rotation = -0.3223;
		items[3].width = 190.22;
		items[3].height = 151.75;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"from icecreamHeart time=0.8 bezier appear ease=backOut delay=0.8","isButton":false,"option":"anyone"});
	}
	if (items[4]) {
		MayaAngelouStoryLayout_ang_afriend_hearts.call(items[4] as IMayaAngelouStoryLayout_ang_afriend_hearts);
		(items[4] as IMayaAngelouStoryLayout_ang_afriend_hearts).animation = "from icecreamHeart time=0.8 bezier appear ease=backOut delay=0.8";
		(items[4] as IMayaAngelouStoryLayout_ang_afriend_hearts).isButton = false;
		(items[4] as IMayaAngelouStoryLayout_ang_afriend_hearts).option = "anyone";
		items[4].x = 1070.85;
		items[4].y = 552;
		items[4].width = 272.00;
		items[4].height = 217.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":true,"option":"one"});
	}
	if (items[5]) {
		MayaAngelouStoryLayout_ang_numberone.call(items[5] as IMayaAngelouStoryLayout_ang_numberone);
		(items[5] as IMayaAngelouStoryLayout_ang_numberone).animation = "squishStretch";
		(items[5] as IMayaAngelouStoryLayout_ang_numberone).isButton = true;
		(items[5] as IMayaAngelouStoryLayout_ang_numberone).option = "one";
		items[5].x = 985.85;
		items[5].y = 1199.55;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch","isButton":true,"option":"fun"});
	}
	if (items[6]) {
		MayaAngelouStoryLayout_ang_tutletastic_yadina.call(items[6] as IMayaAngelouStoryLayout_ang_tutletastic_yadina);
		(items[6] as IMayaAngelouStoryLayout_ang_tutletastic_yadina).animation = "squishStretch";
		(items[6] as IMayaAngelouStoryLayout_ang_tutletastic_yadina).isButton = true;
		(items[6] as IMayaAngelouStoryLayout_ang_tutletastic_yadina).option = "fun";
		items[6].x = 1018.6;
		items[6].y = 1088.55;
		items[6].width = 502.00;
		items[6].height = 566.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch delay=0.2 appear","isButton":true,"option":"fun"});
	}
	if (items[7]) {
		MayaAngelouStoryLayout_ang_tutletastic_xavier.call(items[7] as IMayaAngelouStoryLayout_ang_tutletastic_xavier);
		(items[7] as IMayaAngelouStoryLayout_ang_tutletastic_xavier).animation = "squishStretch delay=0.2 appear";
		(items[7] as IMayaAngelouStoryLayout_ang_tutletastic_xavier).isButton = true;
		(items[7] as IMayaAngelouStoryLayout_ang_tutletastic_xavier).option = "fun";
		items[7].x = 591.35;
		items[7].y = 1168.15;
		items[7].width = 514.00;
		items[7].height = 624.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch delay=0.4 appear","isButton":true,"option":"fun"});
	}
	if (items[8]) {
		MayaAngelouStoryLayout_ang_tutletastic_brad.call(items[8] as IMayaAngelouStoryLayout_ang_tutletastic_brad);
		(items[8] as IMayaAngelouStoryLayout_ang_tutletastic_brad).animation = "squishStretch delay=0.4 appear";
		(items[8] as IMayaAngelouStoryLayout_ang_tutletastic_brad).isButton = true;
		(items[8] as IMayaAngelouStoryLayout_ang_tutletastic_brad).option = "fun";
		items[8].x = 1473;
		items[8].y = 1175.8;
		items[8].width = 403.00;
		items[8].height = 545.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"slideIn down time=2","isButton":true,"option":"fun"});
	}
	if (items[9]) {
		MayaAngelouStoryLayout_drzFun.call(items[9] as IMayaAngelouStoryLayout_drzFun);
		(items[9] as IMayaAngelouStoryLayout_drzFun).animation = "slideIn down time=2";
		(items[9] as IMayaAngelouStoryLayout_drzFun).isButton = true;
		(items[9] as IMayaAngelouStoryLayout_drzFun).option = "fun";
		items[9].x = 1026.8;
		items[9].y = 565.25;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch","isButton":true,"option":"ton"});
	}
	if (items[10]) {
		MayaAngelouStoryLayout_ang_lovedaton.call(items[10] as IMayaAngelouStoryLayout_ang_lovedaton);
		(items[10] as IMayaAngelouStoryLayout_ang_lovedaton).animation = "squishStretch";
		(items[10] as IMayaAngelouStoryLayout_ang_lovedaton).isButton = true;
		(items[10] as IMayaAngelouStoryLayout_ang_lovedaton).option = "ton";
		items[10].x = 1130.6;
		items[10].y = 1205.75;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"scaleUp time=0.6 ease=backOut appear delay=0.2","isButton":false,"option":"ton"});
	}
	if (items[11]) {
		MayaAngelouStoryLayout_ang_lovedaton_heart4.call(items[11] as IMayaAngelouStoryLayout_ang_lovedaton_heart4);
		(items[11] as IMayaAngelouStoryLayout_ang_lovedaton_heart4).animation = "scaleUp time=0.6 ease=backOut appear delay=0.2";
		(items[11] as IMayaAngelouStoryLayout_ang_lovedaton_heart4).isButton = false;
		(items[11] as IMayaAngelouStoryLayout_ang_lovedaton_heart4).option = "ton";
		items[11].x = 1471.5;
		items[11].y = 365.1;
		items[11].width = 247.00;
		items[11].height = 208.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"scaleUp time=0.6 ease=backOut appear delay=0.3","isButton":false,"option":"ton"});
	}
	if (items[12]) {
		MayaAngelouStoryLayout_ang_lovedaton_heart3.call(items[12] as IMayaAngelouStoryLayout_ang_lovedaton_heart3);
		(items[12] as IMayaAngelouStoryLayout_ang_lovedaton_heart3).animation = "scaleUp time=0.6 ease=backOut appear delay=0.3";
		(items[12] as IMayaAngelouStoryLayout_ang_lovedaton_heart3).isButton = false;
		(items[12] as IMayaAngelouStoryLayout_ang_lovedaton_heart3).option = "ton";
		items[12].x = 672.75;
		items[12].y = 632.55;
		items[12].width = 155.00;
		items[12].height = 135.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"scaleUp time=0.6 ease=backOut appear delay=0.5","isButton":false,"option":"ton"});
	}
	if (items[13]) {
		MayaAngelouStoryLayout_ang_lovedaton_heart2.call(items[13] as IMayaAngelouStoryLayout_ang_lovedaton_heart2);
		(items[13] as IMayaAngelouStoryLayout_ang_lovedaton_heart2).animation = "scaleUp time=0.6 ease=backOut appear delay=0.5";
		(items[13] as IMayaAngelouStoryLayout_ang_lovedaton_heart2).isButton = false;
		(items[13] as IMayaAngelouStoryLayout_ang_lovedaton_heart2).option = "ton";
		items[13].x = 1595.8;
		items[13].y = 698.55;
		items[13].width = 117.00;
		items[13].height = 102.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"scaleUp time=0.6 ease=backOut appear delay=0.4","isButton":false,"option":"ton"});
	}
	if (items[14]) {
		MayaAngelouStoryLayout_ang_lovedaton_heart1.call(items[14] as IMayaAngelouStoryLayout_ang_lovedaton_heart1);
		(items[14] as IMayaAngelouStoryLayout_ang_lovedaton_heart1).animation = "scaleUp time=0.6 ease=backOut appear delay=0.4";
		(items[14] as IMayaAngelouStoryLayout_ang_lovedaton_heart1).isButton = false;
		(items[14] as IMayaAngelouStoryLayout_ang_lovedaton_heart1).option = "ton";
		items[14].x = 926.35;
		items[14].y = 298.95;
		items[14].width = 163.00;
		items[14].height = 136.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"slideIn right time=0.8 delay=0.2 appear","isButton":true,"option":"anyone"});
	}
	if (items[15]) {
		MayaAngelouStoryLayout_ang_afriend_beam.call(items[15] as IMayaAngelouStoryLayout_ang_afriend_beam);
		(items[15] as IMayaAngelouStoryLayout_ang_afriend_beam).animation = "slideIn right time=0.8 delay=0.2 appear";
		(items[15] as IMayaAngelouStoryLayout_ang_afriend_beam).isButton = true;
		(items[15] as IMayaAngelouStoryLayout_ang_afriend_beam).option = "anyone";
		items[15].x = 1558.15;
		items[15].y = 595;
		items[15].width = 494.00;
		items[15].height = 511.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"slideIn left time=0.8","isButton":true,"option":"anyone"});
	}
	if (items[16]) {
		MayaAngelouStoryLayout_ang_afriend_drz.call(items[16] as IMayaAngelouStoryLayout_ang_afriend_drz);
		(items[16] as IMayaAngelouStoryLayout_ang_afriend_drz).animation = "slideIn left time=0.8";
		(items[16] as IMayaAngelouStoryLayout_ang_afriend_drz).isButton = true;
		(items[16] as IMayaAngelouStoryLayout_ang_afriend_drz).option = "anyone";
		items[16].x = 635.7;
		items[16].y = 1109.05;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"squishStretch delay=0.6 appear","isButton":false,"option":"anyone"});
	}
	if (items[17]) {
		MayaAngelouStoryLayout_ang_afriend_icecream.call(items[17] as IMayaAngelouStoryLayout_ang_afriend_icecream);
		(items[17] as IMayaAngelouStoryLayout_ang_afriend_icecream).animation = "squishStretch delay=0.6 appear";
		(items[17] as IMayaAngelouStoryLayout_ang_afriend_icecream).isButton = false;
		(items[17] as IMayaAngelouStoryLayout_ang_afriend_icecream).option = "anyone";
		items[17].x = 1051.9;
		items[17].y = 1132.95;
		items[17].width = 467.00;
		items[17].height = 404.00;
		if (items[17].onLayout) items[17].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_afriend_hearts(this: IMayaAngelouStoryLayout_ang_afriend_hearts) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_heart.png", 0.500, 0.502);
	return this;
}
function MayaAngelouStoryLayout_ang_numberone(this: IMayaAngelouStoryLayout_ang_numberone) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzOne.call(items[0] as IMayaAngelouStoryLayout_buttonDrzOne);
		items[0].x = 0;
		items[0].y = -429.5;
		items[0].width = 767.00;
		items[0].height = 859.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzOne(this: IMayaAngelouStoryLayout_buttonDrzOne) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_numberone.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_tutletastic_yadina(this: IMayaAngelouStoryLayout_ang_tutletastic_yadina) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_yadina.png", 0.535, 0.965);
	return this;
}
function MayaAngelouStoryLayout_ang_tutletastic_xavier(this: IMayaAngelouStoryLayout_ang_tutletastic_xavier) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_xavier.png", 0.500, 1.002);
	return this;
}
function MayaAngelouStoryLayout_ang_tutletastic_brad(this: IMayaAngelouStoryLayout_ang_tutletastic_brad) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_brad.png", 0.500, 1.000);
	return this;
}
function MayaAngelouStoryLayout_drzFun(this: IMayaAngelouStoryLayout_drzFun) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float time=1.4 speed=0.5","isButton":false,"option":"fun"});
	}
	if (items[0]) {
		MayaAngelouStoryLayout_ang_tutletastic_drz.call(items[0] as IMayaAngelouStoryLayout_ang_tutletastic_drz);
		(items[0] as IMayaAngelouStoryLayout_ang_tutletastic_drz).animation = "float time=1.4 speed=0.5";
		(items[0] as IMayaAngelouStoryLayout_ang_tutletastic_drz).isButton = false;
		(items[0] as IMayaAngelouStoryLayout_ang_tutletastic_drz).option = "fun";
		items[0].x = 0;
		items[0].y = -213;
		items[0].width = 339.00;
		items[0].height = 426.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_ang_tutletastic_drz(this: IMayaAngelouStoryLayout_ang_tutletastic_drz) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_tutletastic_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_lovedaton(this: IMayaAngelouStoryLayout_ang_lovedaton) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzLove.call(items[0] as IMayaAngelouStoryLayout_buttonDrzLove);
		items[0].x = 0;
		items[0].y = -429;
		items[0].width = 808.00;
		items[0].height = 858.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzLove(this: IMayaAngelouStoryLayout_buttonDrzLove) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_lovedaton_heart4(this: IMayaAngelouStoryLayout_ang_lovedaton_heart4) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart4.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_lovedaton_heart3(this: IMayaAngelouStoryLayout_ang_lovedaton_heart3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart3.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_lovedaton_heart2(this: IMayaAngelouStoryLayout_ang_lovedaton_heart2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart2.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_lovedaton_heart1(this: IMayaAngelouStoryLayout_ang_lovedaton_heart1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_lovedaton_heart1.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_afriend_beam(this: IMayaAngelouStoryLayout_ang_afriend_beam) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_berbie.png", 0.500, 0.501);
	return this;
}
function MayaAngelouStoryLayout_ang_afriend_drz(this: IMayaAngelouStoryLayout_ang_afriend_drz) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		MayaAngelouStoryLayout_buttonDrzIcecream.call(items[0] as IMayaAngelouStoryLayout_buttonDrzIcecream);
		items[0].x = 0;
		items[0].y = -158;
		items[0].width = 516.00;
		items[0].height = 316.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function MayaAngelouStoryLayout_buttonDrzIcecream(this: IMayaAngelouStoryLayout_buttonDrzIcecream) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_drz.png", 0.500, 0.500);
	return this;
}
function MayaAngelouStoryLayout_ang_afriend_icecream(this: IMayaAngelouStoryLayout_ang_afriend_icecream) {
	if (this.setLayoutTexture) this.setLayoutTexture("ang_afriend_icecream.png", 0.501, 1.000);
	return this;
}
interface IMayaAngelouStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMayaAngelouStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMayaAngelouStoryLayoutSprite extends IMayaAngelouStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMayaAngelouStoryLayoutText extends IMayaAngelouStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMayaAngelouStoryLayoutPolygon extends Array<number> {
}
interface IMayaAngelouStoryLayout {
	readonly scene1Start: IMayaAngelouStoryLayout_scene1Start;
	readonly scene2Likes: IMayaAngelouStoryLayout_scene2Likes;
	readonly scene3Brave: IMayaAngelouStoryLayout_scene3Brave;
	readonly scene4Dance: IMayaAngelouStoryLayout_scene4Dance;
	readonly scene5Power: IMayaAngelouStoryLayout_scene5Power;
	readonly scene6Bed: IMayaAngelouStoryLayout_scene6Bed;
	readonly scene7End: IMayaAngelouStoryLayout_scene7End;
}
interface IMayaAngelouStoryLayout_scene1Start extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_counterpart_drz_2|IMayaAngelouStoryLayout_ang_counterpart_drz_1|IMayaAngelouStoryLayout_drzOnChalkboard|IMayaAngelouStoryLayout_ang_art|IMayaAngelouStoryLayout_ang_art_drz|IMayaAngelouStoryLayout_ang_heart_3|IMayaAngelouStoryLayout_ang_heart_2|IMayaAngelouStoryLayout_drzHeart|IMayaAngelouStoryLayout_ang_counterpart>;
}
interface IMayaAngelouStoryLayout_ang_counterpart_drz_2 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonYadinaCounterpart>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonYadinaCounterpart extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_counterpart_drz_1 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzCounterpart>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzCounterpart extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzOnChalkboard extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_smart|IMayaAngelouStoryLayout_ang_smart_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_smart extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_smart_drz extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_art extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_art_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_drzButtonArt>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzButtonArt extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_heart_3 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_heart_2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzHeart extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_heart_drz|IMayaAngelouStoryLayout_ang_heart_1|IMayaAngelouStoryLayout_ang_heart_drz_front>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_heart_drz extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_heart_1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_heart_drz_front extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_counterpart extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_scene2Likes extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_turtle_drink_3|IMayaAngelouStoryLayout_ang_marshmallowsbg|IMayaAngelouStoryLayout_ang_teaset|IMayaAngelouStoryLayout_ang_sandwich|IMayaAngelouStoryLayout_ang_sandwich_drz|IMayaAngelouStoryLayout_ang_turtle_balloons_2|IMayaAngelouStoryLayout_ang_turtle_drz|IMayaAngelouStoryLayout_ang_marshmallows3|IMayaAngelouStoryLayout_ang_marshmallows2|IMayaAngelouStoryLayout_ang_marshmallows1|IMayaAngelouStoryLayout_drzPie|IMayaAngelouStoryLayout_ang_sea_fish|IMayaAngelouStoryLayout_ang_sea_whale|IMayaAngelouStoryLayout_ang_sea_plant2|IMayaAngelouStoryLayout_ang_sea_plant1|IMayaAngelouStoryLayout_ang_sea_bubbles11|IMayaAngelouStoryLayout_ang_sea_bubbles21|IMayaAngelouStoryLayout_ang_sea_drz1>;
}
interface IMayaAngelouStoryLayout_ang_turtle_drink_3 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_marshmallowsbg extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_teaset extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sandwich extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sandwich_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzJelly>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzJelly extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_turtle_balloons_2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_turtle_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzParty>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzParty extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_marshmallows3 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_marshmallows2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_marshmallows1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzPie extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_pie|IMayaAngelouStoryLayout_ang_pie_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pie extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pie_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzMarshmellow>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzMarshmellow extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_sea_fish extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_fishFloat>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_fishFloat extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_whale extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_whaleFloat>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_whaleFloat extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_plant2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_plant1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_bubbles11 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sea_bubbles1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_bubbles1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_bubbles21 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sea_bubbles2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_bubbles2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_drz1 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sea_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sea_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzSea>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzSea extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_scene3Brave extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_wings_cloud3|IMayaAngelouStoryLayout_ang_wings_cloud2|IMayaAngelouStoryLayout_ang_wings_cloud1|IMayaAngelouStoryLayout_ang_springs_duck_right|IMayaAngelouStoryLayout_ang_springs_duck_left|IMayaAngelouStoryLayout_ang_springs_spring|IMayaAngelouStoryLayout_ang_springs_butterflies_2|IMayaAngelouStoryLayout_ang_springs_butterflies_1|IMayaAngelouStoryLayout_paperLayer|IMayaAngelouStoryLayout_drzWings|IMayaAngelouStoryLayout_ang_springs_drz|IMayaAngelouStoryLayout_ang_onionrings|IMayaAngelouStoryLayout_ang_onionrings_drz|IMayaAngelouStoryLayout_buttonDrzSwings1>;
}
interface IMayaAngelouStoryLayout_ang_wings_cloud3 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_wings_cloud2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_wings_cloud1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_duck_right extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_duck_left extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_spring extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_butterflies_2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_butterflies_1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_paperLayer extends IMayaAngelouStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface IMayaAngelouStoryLayout_drzWings extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_wings_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_wings_drz extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_springs_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzSprings>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzSprings extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_onionrings extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_onionrings_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzRings>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzRings extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_buttonDrzSwings1 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_swing_bg|IMayaAngelouStoryLayout_ang_swing_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_swing_bg extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_swing_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzSwings>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzSwings extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_scene4Dance extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_dance_stereo|IMayaAngelouStoryLayout_ang_dance_speakerright|IMayaAngelouStoryLayout_ang_dance_speakerleft|IMayaAngelouStoryLayout_notesParticles|IMayaAngelouStoryLayout_paperLayer|IMayaAngelouStoryLayout_drzBallons|IMayaAngelouStoryLayout_drzMoon|IMayaAngelouStoryLayout_drzSpoon|IMayaAngelouStoryLayout_drzRacoon>;
}
interface IMayaAngelouStoryLayout_ang_dance_stereo extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_dance_speakerright extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_dance_speakerleft extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_notesParticles extends IMayaAngelouStoryLayoutContainer {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzBallons extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_drzBalloon1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzBalloon1 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_balloon|IMayaAngelouStoryLayout_ang_balloon_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_balloon extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_balloon_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzBalloon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzBalloon extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzMoon extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_moon|IMayaAngelouStoryLayout_ang_moon_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_moon extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_moon_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzMoon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzMoon extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzSpoon extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_drzSpoonDance>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzSpoonDance extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_spoon|IMayaAngelouStoryLayout_ang_spoon_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_spoon extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_spoon_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzSpoon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzSpoon extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzRacoon extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_raccoon_drz|IMayaAngelouStoryLayout_ang_raccoon|IMayaAngelouStoryLayout_ang_raccoon_drz_front>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_raccoon_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzRaccoon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzRaccoon extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_raccoon extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_raccoon_drz_front extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_scene5Power extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_pizzatower_left|IMayaAngelouStoryLayout_ang_sittingstill|IMayaAngelouStoryLayout_buttonDrzShower1|IMayaAngelouStoryLayout_ang_flower_right|IMayaAngelouStoryLayout_ang_flower_left|IMayaAngelouStoryLayout_ang_flower|IMayaAngelouStoryLayout_ang_flower_drz|IMayaAngelouStoryLayout_drzTower|IMayaAngelouStoryLayout_ang_sittingstill_drz|IMayaAngelouStoryLayout_clock|IMayaAngelouStoryLayout_paperLayer|IMayaAngelouStoryLayout_ang_pizzatower_brad|IMayaAngelouStoryLayout_ang_pizzatower__xavier|IMayaAngelouStoryLayout_ang_pizzatower_yadina>;
}
interface IMayaAngelouStoryLayout_ang_pizzatower_left extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sittingstill extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzShower1 extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_shower_dzr|IMayaAngelouStoryLayout_ang_shower|IMayaAngelouStoryLayout_ang_shower_dzr_front|IMayaAngelouStoryLayout_notesParticles>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_shower_dzr extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzShower>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzShower extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_shower extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_shower_dzr_front extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_flower_right extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_flower_left extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_flower extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_flower_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzFlower>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzFlower extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzTower extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_pizzatower_right|IMayaAngelouStoryLayout_ang_pizzatower_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pizzatower_right extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pizzatower_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzTower>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzTower extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_sittingstill_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzHour>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzHour extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_clock extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sittingstill_clock|IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin|IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sittingstill_clock extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sittingstill_clock_handMin extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sittingstill_clock_handHr extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pizzatower_brad extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pizzatower__xavier extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pizzatower_yadina extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_scene6Bed extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sled_pillow_back|IMayaAngelouStoryLayout_paperLayer|IMayaAngelouStoryLayout_drzSled|IMayaAngelouStoryLayout_ang_bread|IMayaAngelouStoryLayout_ang_bread_drz|IMayaAngelouStoryLayout_drzBed|IMayaAngelouStoryLayout_ang_pillow|IMayaAngelouStoryLayout_ang_sled_pillow_front|IMayaAngelouStoryLayout_notesParticles|IMayaAngelouStoryLayout_ang_pillow_drz>;
}
interface IMayaAngelouStoryLayout_ang_sled_pillow_back extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzSled extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sled|IMayaAngelouStoryLayout_ang_sled_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sled extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sled_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzSled>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzSled extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_bread extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_bread_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzBread>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzBread extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_drzBed extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_sleepyhead_bed|IMayaAngelouStoryLayout_ang_sleepyhead_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sleepyhead_bed extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_sleepyhead_drz extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pillow extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_pillowBounce>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_pillowBounce extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_pillowInner>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_pillowInner extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_sled_pillow_front extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_pillow_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_drzPillowBounce>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzPillowBounce extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzPillow>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzPillow extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_scene7End extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_afriend_hearts|IMayaAngelouStoryLayout_ang_numberone|IMayaAngelouStoryLayout_ang_tutletastic_yadina|IMayaAngelouStoryLayout_ang_tutletastic_xavier|IMayaAngelouStoryLayout_ang_tutletastic_brad|IMayaAngelouStoryLayout_drzFun|IMayaAngelouStoryLayout_ang_lovedaton|IMayaAngelouStoryLayout_ang_lovedaton_heart4|IMayaAngelouStoryLayout_ang_lovedaton_heart3|IMayaAngelouStoryLayout_ang_lovedaton_heart2|IMayaAngelouStoryLayout_ang_lovedaton_heart1|IMayaAngelouStoryLayout_ang_afriend_beam|IMayaAngelouStoryLayout_ang_afriend_drz|IMayaAngelouStoryLayout_ang_afriend_icecream>;
}
interface IMayaAngelouStoryLayout_ang_afriend_hearts extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_numberone extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzOne>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzOne extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_tutletastic_yadina extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_tutletastic_xavier extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_tutletastic_brad extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_drzFun extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_ang_tutletastic_drz>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_tutletastic_drz extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_lovedaton extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzLove>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzLove extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_lovedaton_heart4 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_lovedaton_heart3 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_lovedaton_heart2 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_lovedaton_heart1 extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_afriend_beam extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_ang_afriend_drz extends IMayaAngelouStoryLayoutContainer {
	readonly items: IMayaAngelouStoryLayoutArray<IMayaAngelouStoryLayout_buttonDrzIcecream>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface IMayaAngelouStoryLayout_buttonDrzIcecream extends IMayaAngelouStoryLayoutSprite {
}
interface IMayaAngelouStoryLayout_ang_afriend_icecream extends IMayaAngelouStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
